import React, { Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Table, Row, Label, Modal, ModalHeader, ModalBody, ModalFooter, Collapse, UncontrolledTooltip, ListGroup, ListGroupItem } from 'reactstrap';
import Flatpickr from "react-flatpickr";
import BreadCrumb from '../components/Common/BreadCrumb';
import dateFormat from "dateformat";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import moment from "moment";
import emailValidator from 'email-validator';
import logoApproved from "../assets/images/approved.jpeg";
import logoRejected from "../assets/images/rejected.jpeg";

import { createDeepClone, api } from "../utils/index";

import CardLoader from "../components/CardLoader";
import Lookup from "../components/Lookup";
import CustomerLookup from "../components/CustomerLookup";
import { Highlighter, Menu, MenuItem, } from 'react-bootstrap-typeahead';
import ConfirmModal from "../components/ConfirmModal";
import ConfirmModalAdvanced from "../components/ConfirmModalAdvanced";
import ErrorModal from "../components/ErrorModal";
import InfoModal from "../components/InfoModal";
import GoogleMapModal from "../components/GoogleMapModal";
import TicketGrid from "../components/TicketGrid";
import TicketProductGrid from "../components/TicketProductGrid";
import TicketProductPhotoGrid from "../components/TicketProductPhotoGrid";
import ServiceDocumentGrid from "../components/ServiceDocumentGrid";
import CommentGrid from "../components/CommentGrid";
import RelatedTicketList from "../components/RelatedTicketList";
import ActionList from "../components/ActionList";
import MyNumberRenderer from "../components/MyNumberRenderer";
import ComplianceLabel from "../components/ComplianceLabel";
import NonConformityLabel from "../components/NonConformityLabel";

import FormProductChecklistSASO from "../components/FormProductChecklistSASO";
import FormReviewSASO from "../components/FormReviewSASO";
import FormEvaluationSASO from "../components/FormEvaluationSASO";
import FormDecisionSASO from "../components/FormDecisionSASO";
import FormReadyToIssueSASO from "../components/FormReadyToIssueSASO";

import FormReviewSFDA from "../components/FormReviewSFDA";
import FormEvaluationSFDA from "../components/FormEvaluationSFDA";
import FormDecisionSFDA from "../components/FormDecisionSFDA";

import FormReviewFOOD from "../components/FormReviewFOOD";
import FormEvaluationFOOD from "../components/FormEvaluationFOOD";
import FormDecisionFOOD from "../components/FormDecisionFOOD";

import VendorScreen from "./VendorScreen";

import { useDispatch, useSelector } from "react-redux";
import * as ticketActions from "../actions/TicketActions";
import * as commonActions from "../actions/CommonActions";

const TicketEditScreen  = () => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id } = useParams();

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.ticket.loadingFBO);
    const loadingTicketInvoice = useSelector((state) => state.ticket.loadingTicketInvoice);
    const loadingTicketInvoiceContracts = useSelector((state) => state.ticket.loadingTicketInvoiceContracts);
    const loadingTicketInvoiceProducts = useSelector((state) => state.ticket.loadingTicketInvoiceProducts);
    
    const user = useSelector((state) => state.login.user);
    const fbo = useSelector((state) => state.ticket.fbo);
    const ticketInvoice = useSelector((state) => state.ticket.ticketInvoice);
    const ticketInvoiceContractList = useSelector((state) => state.ticket.ticketInvoiceContractList);
    const ticketInvoiceProductList = useSelector((state) => state.ticket.ticketInvoiceProductList);
    const serviceList = useSelector((state) => state.login.data.serviceList);
    const technicalRegulationList = useSelector((state) => state.login.data.technicalRegulationList);
    
    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [loadingLocal, setLoadingLocal] = React.useState(false);
    const [loadingStarted, setLoadingStarted] = React.useState(false);
    const [errorMessages, setErrorMessages] = React.useState([]);
    const [warningMessages, setWarningMessages] = React.useState([]);
    const [refreshAction, setRefreshAction] = React.useState(false);
    const [isContainer, setIsContainer] = React.useState(false);
    const [isChild, setIsChild] = React.useState(false);
    const [isTicket, setIsTicket] = React.useState(false);
    const [isFactoryAudit, setIsFactoryAudit] = React.useState(false);
    const [selectedTechnicalRegulation, setSelectedTechnicalRegulation] = React.useState([]);
    const [selectedReporter, setSelectedReporter] = React.useState([]);
    const [selectedTag, setSelectedTag] = React.useState([]);
    const [selectedTagOther, setSelectedTagOther] = React.useState([]);
    const [selectedCustomer, setSelectedCustomer] = React.useState([]);
    const [selectedManufacturer, setSelectedManufacturer] = React.useState([]);
    const [selectedImporter, setSelectedImporter] = React.useState([]);
    const [selectedExporter, setSelectedExporter] = React.useState([]);
    const [selectedReviewer, setSelectedReviewer] = React.useState([]);
    const [selectedInspector, setSelectedInspector] = React.useState([]);
    const [selectedSasoRequestNumber, setSelectedSasoRequestNumber] = React.useState([]);
    const [selectedStatus, setSelectedStatus] = React.useState("");
    const [currentMessage, setCurrentMessage] = React.useState("");
    const [productNameQuery, setProductNameQuery] = React.useState("");
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    const [showSubmitModal, setShowSubmitModal] = React.useState(false);
    const [showSubmitConfirmModal, setShowSubmitConfirmModal] = React.useState(false);
    const [showReSubmitModal, setShowReSubmitModal] = React.useState(false);
    const [showInProgressModal, setShowInProgressModal] = React.useState(false);
    const [showAcceptModal, setShowAcceptModal] = React.useState(false);
    const [showRejectModal, setShowRejectModal] = React.useState(false);
    const [showSalesActionModal, setShowSalesActionModal] = React.useState(false);
    const [showPdReviewModal, setShowPdReviewModal] = React.useState(false);
    const [showTechnicalReviewModal, setShowTechnicalReviewModal] = React.useState(false);
    const [showTechnicalSupportModal, setShowTechnicalSupportModal] = React.useState(false);
    const [showApprovePdModal, setShowApprovePdModal] = React.useState(false);
    const [showRejectPdModal, setShowRejectPdModal] = React.useState(false);
    const [showFinalDecisionModal, setShowFinalDecisionModal] = React.useState(false);
    const [showReadyToIssueModal, setShowReadyToIssueModal] = React.useState(false);
    const [showScheduledModal, setShowScheduledModal] = React.useState(false);
    const [showWaitingCorrectiveActionModal, setShowWaitingCorrectiveActionModal] = React.useState(false);
    const [showDataReviewModal, setShowDataReviewModal] = React.useState(false);
    const [showPhase1EvaluationModal, setShowPhase1EvaluationModal] = React.useState(false);
    const [showPhase2EvaluationModal, setShowPhase2EvaluationModal] = React.useState(false);
    const [showStoppedModal, setShowStoppedModal] = React.useState(false);
    const [showAbortModal, setShowAbortModal] = React.useState(false);
    const [showCompleteModal, setShowCompleteModal] = React.useState(false);
    const [showCloseModal, setShowCloseModal] = React.useState(false);
    const [showCancelModal, setShowCancelModal] = React.useState(false);
    const [showNonConformityModal, setShowNonConformityModal] = React.useState(false);
    const [showAcceptNonConformityModal, setShowAcceptNonConformityModal] = React.useState(false);
    const [showRejectNonConformityModal, setShowRejectNonConformityModal] = React.useState(false);
    const [showResetToDraftModal, setShowResetToDraftModal] = React.useState(false);
    const [showResetToSamplingInProcessModal, setShowResetToSamplingInProcessModal] = React.useState(false);
    const [showResetToInspectionInProcessModal, setShowResetToInspectionInProcessModal] = React.useState(false);
    const [showNotifyCreateInvoiceModal, setShowNotifyCreateInvoiceModal] = React.useState(false);
    const [showNotifySadadPaymentModal, setShowNotifySadadPaymentModal] = React.useState(false);
    const [showNotifySadadPaidModal, setShowNotifySadadPaidModal] = React.useState(false);
    const [showNCRModal, setShowNCRModal] = React.useState(false);
    const [showVerifiedModal, setShowVerifiedModal] = React.useState(false);
    const [showRemoveInvoiceModal, setShowRemoveInvoiceModal] = React.useState(false);
    const [autoCloseShown, setAutoCloseShown] = React.useState(false);
    const [showAutoCloseModal, setShowAutoCloseModal] = React.useState(false);
    const [showInvoiceCreateModal, setShowInvoiceCreateModal] = React.useState(false);
    const [showInvoiceViewModal, setShowInvoiceViewModal] = React.useState(false);
    const [showContractModal, setShowContractModal] = React.useState(false);
    const [showCreateSamplingModal, setShowCreateSamplingModal] = React.useState(false);
    const [showCreateInspectionModal, setShowCreateInspectionModal] = React.useState(false);
    const [showApproveFormReviewSFDAModal, setShowApproveFormReviewSFDAModal] = React.useState(false);
    const [approverFormReviewSFDA, setApproverFormReviewSFDA] = React.useState(0);
    const [certificateTypeValid, setCertificateTypeValid] = React.useState(true);
    const [testReportValid, setTestReportValid] = React.useState(true);
    const [samplingInitiatedByValid, setSamplingInitiatedByValid] = React.useState(true);
    const [inspectionStartDateValid, setInspectionStartDateValid] = React.useState(true);
    const [inspectionEndDateValid, setInspectionEndDateValid] = React.useState(true);
    const [inspectionAddressValid, setInspectionAddressValid] = React.useState(true);
    const [inspectionCountryValid, setInspectionCountryValid] = React.useState(true);
    const [inspectionCityValid, setInspectionCityValid] = React.useState(true);
    const [clientAddressValid, setClientAddressValid] = React.useState(true);
    const [clientContactValid, setClientContactValid] = React.useState(true);
    const [productLocationValid, setProductLocationValid] = React.useState(true);
    const [requestSubTypeValid, setRequestSubTypeValid] = React.useState(true);
    const [regionValid, setRegionValid] = React.useState(true);
    const [factoryAuditCategoryValid, setFactoryAuditCategoryValid] = React.useState(true);
    const [factoryAuditContactEmailValid, setFactoryAuditContactEmailValid] = React.useState(true);
    const [factoryAuditReviewerEmailValid, setFactoryAuditReviewerEmailValid] = React.useState(true);
    const [inspectionPersonEmailValid, setInspectionPersonEmailValid] = React.useState(true);
    const [listPriceValid, setListPriceValid] = React.useState(true);
    const [discountValid, setDiscountValid] = React.useState(true);
    const [discountErrorMessage, setDiscountErrorMessage] = React.useState(true);
    const [currencyValid, setCurrencyValid] = React.useState(true);
    const [customerValid, setCustomerValid] = React.useState(true);
    const [crmNameValid, setCrmNameValid] = React.useState(true);
    const [crmCountryValid, setCrmCountryValid] = React.useState(true);
    const [sasoRequestNumberValid, setSasoRequestNumberValid] = React.useState(true);
    const [showCustomerError, setShowCustomerError] = React.useState(false);
    const [showInvoiceError, setShowInvoiceError] = React.useState(false);
    const [showVendorFormModal, setShowVendorFormModal] = React.useState(false);
    const [vendorFormType, setVendorFormType] = React.useState("");
    const [showStatusMessage, setShowStatusMessage] = React.useState(true);
    const [showGoogleMap, setShowGoogleMap] = React.useState(false);

    const [showGroupUserVsReporterSelectionError, setShowGroupUserVsReporterSelectionError] = React.useState(false);
    const [showGroupUserVsDecisionMakerSelectionError, setShowGroupUserVsDecisionMakerSelectionError] = React.useState(false);
    const [showDecisionMakerVsReporterSelectionError, setShowDecisionMakerVsReporterSelectionError] = React.useState(false);
    const [showDecisionMakerVsGroupUserSelectionError, setShowDecisionMakerVsGroupUserSelectionError] = React.useState(false);
    const [showPdGroupUserVsDecisionMakerSelectionError, setShowPdGroupUserVsDecisionMakerSelectionError] = React.useState(false);
    const [showPdDecisionMakerVsGroupUserSelectionError, setShowPdDecisionMakerVsGroupUserSelectionError] = React.useState(false);

    const [invoiceInformationCollapsed, setInvoiceInformationCollapsed] = React.useState(true);
    const [relatedTicketCollapsed, setRelatedTicketCollapsed] = React.useState(true);
    const [checklistFormCollapsed, setChecklistFormCollapsed] = React.useState(true);
    
    React.useEffect(() => {
	    dispatch(ticketActions.loadTicket(id, navigate));
        setLoadingStarted(true);
    }, [id]);
    
    React.useEffect(() => {
        setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        setSelectedTechnicalRegulation([]);
        setSelectedReporter([]);
        setSelectedTag([]);
        setSelectedTagOther([]);
        setSelectedCustomer([]);
        setSelectedManufacturer([]);
        setSelectedImporter([]);
        setSelectedExporter([]);
        setSelectedReviewer([]);
        setSelectedInspector([]);
        setSelectedSasoRequestNumber([]);

        setIsContainer(false);
        setIsChild(false);
        setIsTicket(false);
        setIsFactoryAudit(false);

        if(fbo) {
            if(fbo.ticket.ticketType === "CONTAINER") {
                setIsContainer(true);
            }
            else if(fbo.ticket.ticketType === "CHILD") {
                setIsChild(true);
            }
            else if(fbo.ticket.ticketType === "TICKET") {
                setIsTicket(true);
            }

            if(fbo.ticket.serviceId === 4) {
                setIsFactoryAudit(true);
            }
        }
        
        if(fbo != null) {
            reset(fbo.ticket);
            
            if(fbo.technicalRegulations != null) {
                setSelectedTechnicalRegulation(fbo.technicalRegulations);
            }
            
            if(fbo.reporter != null) {
                setSelectedReporter(fbo.reporter);
            }

            if(fbo.tagList != null) {
                setSelectedTag(fbo.tagList);
            }

            if(fbo.otherTagList != null) {
                setSelectedTagOther(fbo.otherTagList);
            }
            
            if(fbo.customer != null) {
                setSelectedCustomer([fbo.customer]);
            }

            if(fbo.manufacturer != null) {
                setSelectedManufacturer([fbo.manufacturer]);
            }

            if(fbo.importer != null) {
                setSelectedImporter([fbo.importer]);
            }

            if(fbo.exporter != null) {
                setSelectedExporter([fbo.exporter]);
            }

            if(fbo.reviewer != null) {
                setSelectedReviewer([fbo.reviewer]);
            }

            if(fbo.inspector != null) {
                setSelectedInspector([fbo.inspector]);
            }

            var sasoItems = [];
            var sasoCounter = 0;

            if(fbo.ticket.sasoRequestNumber) {
                sasoCounter = 1;

                fbo.ticket.sasoRequestNumber.split(",").forEach(element => {
                    sasoItems.push(element);
                    sasoCounter += 1;
                });
            }

            while(sasoCounter < fbo.ticket.quantity) {
                sasoItems.push("");
                sasoCounter += 1;
            }

            setSelectedSasoRequestNumber(sasoItems);

            if(!fbo.canCreateInvoice) {
                setShowInvoiceCreateModal(false);
            }

            if(fbo.ticket.id == id) {
                if(fbo.ticket.statusMessage && showStatusMessage) {
                    dispatch(commonActions.setErrorMessage(fbo.ticket.statusMessage));
                    setShowStatusMessage(false);
                }

                if(loadingStarted) {
                    validateTicketAutoClose(fbo);
                }
            }
        }

        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onChangeDocument = (isProduct, document) => {
        if(isProduct) {
            if(fboState && fboState.ticket.isProductCertificateAvailable) {
                dispatch(ticketActions.loadProductChecklist(fboState, fboState.ticket.id, "ProductChecklist", "SASO"));
            }
        }

        if(document && document.documentType === "CR" && document.certificateType && fboState && fboState.ticket.certificateCategory !== document.certificateType) {
            var copy_fboState = createDeepClone(fboState);
            copy_fboState.ticket.certificateCategory = document.certificateType;
            setFBOState(copy_fboState);
        }

        if(fboState) {
            if((fboState.ticket.isSamplingAvailable && fboState.isPendingForSampling) || (fboState.ticket.isInspectionAvailable && fboState.isPendingForInspection)) {
                dispatch(ticketActions.saveTicket(fboState, selectedStatus, currentMessage, false, navigate));
            }

            validateTicketAutoClose(fboState);
        }
                
        setRefreshAction(!refreshAction);
    }

    const getFormattedDate = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy");
        }
        return "";
    }

    const getFormattedDateTime = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy HH:MM");
        }
        return "";
    }

    const getDateWithoutTimezone = (value) => {
        if(value) {
            const tzoffset = value.getTimezoneOffset() * 60000;
            const withoutTimezone = new Date(value.valueOf() - tzoffset).toISOString().slice(0, -1);
            return withoutTimezone;
        }
        return "";
    }

    const isCustomerReadonly = () => {
        if(isChild || (fboState && (fboState.ticket.crmInvoiceId || fboState.ticket.lineId || fboState.ticket.status === "Closed" || fboState.ticket.status === "Cancelled"))) {
            return true;
        }

        return false;
    }

    const isPricingReadonly = () => {
        if(fboState && fboState.ticket.productType === "PRODUCT") {
            return false;
        }
        
        return true;
    }

    const getVatList = () => {
        var vatList = [0];

        if(fboState && fboState.crmCountryList) {
            var country = fboState.crmCountryList.find(x => x.crmName === fboState?.ticket.crmName && x.countryName === fboState.ticket.crmCountry);
            if(country != null) {
                vatList = country.vatList;
            }
        }
        
        return vatList;
    }

    const isDecisionMakerExternal = () => {
        if(fboState && fboState.useExternalDecisionMaker && fboState.ticket.region === "Europe" && (fboState.ticket.requestSubType === "Type 1a" || fboState.ticket.requestSubType === "Type 3")) {
            return true;
        }
        
        return false;
    }

    const showLinkedTickets = () => {
        if(fboState && (fboState.ticket.inspectionChildId || fboState.ticket.samplingChildId || fboState.ticket.inspectionParentId || fboState.ticket.samplingParentId)) {
            return true;
        }
        
        return false;
    }

    

    const getGroupList = (includeGroupId) => {
        var arrGroupList = [];

        if(fboState) {
            if(fboState.ticket.isReviewAvailable) {
                fboState.groupList.forEach((group, i) => {
                    arrGroupList.push(group);
                });
            }
            else if(fboState.ticket.isCosmeticAvailable) {
                fboState.groupList.forEach((group, i) => {
                    if(group.id == includeGroupId || group.isCosmetic) {
                        arrGroupList.push(group);
                    }
                });
            }
            else if(fboState.ticket.isProcessedFoodAvailable) {
                fboState.groupList.forEach((group, i) => {
                    if(group.id == includeGroupId || group.isFood) {
                        arrGroupList.push(group);
                    }
                });
            }
            else if(fboState.ticket.isFreshFoodAvailable) {
                fboState.groupList.forEach((group, i) => {
                    if(group.id == includeGroupId || group.isFreshFood) {
                        arrGroupList.push(group);
                    }
                });
            }
            else if(fboState.ticket.isChilledFoodAvailable) {
                fboState.groupList.forEach((group, i) => {
                    if(group.id == includeGroupId || group.isChilledFood) {
                        arrGroupList.push(group);
                    }
                });
            }
            else {
                fboState.groupList.forEach((group, i) => {
                    if(group.id == includeGroupId || (!group.isCosmetic && !group.isFood && !group.isFreshFood && !group.isChilledFood)) {
                        arrGroupList.push(group);
                    }
                });
            }
        }

        return arrGroupList;
    }

    const getDecisionMakerList = () => {
        var arrDecisionMaker = [];

        if(fboState) {
            if(fboState.ticket.isFactoryAudit) {
                if(fboState.pdGroupUserList) {
                    var currentUserId = fboState.ticket.decisionUserId;
                    var found = false;
        
                    fboState.pdGroupUserList.forEach((pdGroupUser, i) => {
                        if(pdGroupUser.groupId == fboState.ticket.pdGroupId) {
                            arrDecisionMaker.push(pdGroupUser);
        
                            if(pdGroupUser.userId === currentUserId) {
                                found = true;
                            }
                        }
                    });
                            
                    if(found === false) {
                        fboState.pdGroupUserList.forEach((pdGroupUser, i) => {
                            if(pdGroupUser.groupId == fboState.ticket.pdGroupId && found === false) {
                                if(pdGroupUser.userId === currentUserId) {
                                    arrDecisionMaker.push(pdGroupUser)
                                    found = true;
                                }
                            }
                        });
                    }
                }
            }
            else {
                if(fboState.groupUserList) {
                    var currentUserId = fboState.ticket.decisionUserId;
                    var found = false;
        
                    if(isDecisionMakerExternal()) {
                        fboState.groupUserList.forEach((groupUser, i) => {
                            if(groupUser.groupId == fboState.ticket.groupId && groupUser.isDecisionMakerExternal === true) {
                                arrDecisionMaker.push(groupUser);
            
                                if(groupUser.userId === currentUserId) {
                                    found = true;
                                }
                            }
                        });
                    }
                    else{
                        fboState.groupUserList.forEach((groupUser, i) => {
                            if(groupUser.groupId == fboState.ticket.groupId && groupUser.isDecisionMaker === true) {
                                arrDecisionMaker.push(groupUser);
            
                                if(groupUser.userId === currentUserId) {
                                    found = true;
                                }
                            }
                        });
                    }
        
                    if(found === false) {
                        fboState.groupUserList.forEach((groupUser, i) => {
                            if(groupUser.groupId == fboState.ticket.groupId && found === false) {
                                if(groupUser.userId === currentUserId) {
                                    arrDecisionMaker.push(groupUser)
                                    found = true;
                                }
                            }
                        });
                    }
                }
            }
        }
        
        return arrDecisionMaker;
    }

    const onTicketChange = (name, value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value) {
            if(name === "nonRegulatedCount") {
                value = value.replace(/[^0-9]/g, '');
            }
            else if(name === "fob" || name === "listPrice" || name === "discountValue") {
                value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
            }
            else if(name === "inspectionLatitude" || name === "inspectionLongitude") {
                value = value.replace(/[^0-9.-]/g, '').replace(/(?!^)-/g, '').replace(/(\..*)\./g, '$1');
            }
            
            if(name === "certificateIssueDate" || name === "factoryAuditDate" || name === "inspectionStartDate" || name === "inspectionEndDate" || name === "samplingDate") {
                copy_fboState.ticket[name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.ticket[name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.ticket[name] = false;
        }
        else {
            copy_fboState.ticket[name] = null;
        }

        if(name === "listPrice" || name === "discountType" || name === "discountValue" || name === "vatPercentage") {
            copy_fboState = calculationTicketPricing(copy_fboState);
        }

        if(name === "crmName" || name === "crmCountry") {
            copy_fboState.ticket["customerId"] = null;
            setSelectedCustomer([]);
        }

        if(name === "customerId") {
            if(copy_fboState.ticket["productType"] === "CONTRACT") {
                copy_fboState.ticket["productId"] = "";
                copy_fboState.ticket["productType"] = "PRODUCT";
                copy_fboState.ticket["productName"] = "";
                copy_fboState.ticket["productDescription"] = "";
                copy_fboState.ticket["currency"] = "";
                copy_fboState.ticket["listPrice"] = 0;
                copy_fboState.ticket["discountValue"] = 0;
                copy_fboState.ticket["discountType"] = "Percentage";
                copy_fboState.ticket["vatPercentage"] = 0;

                copy_fboState = calculationTicketPricing(copy_fboState);
            }
        }

        if(name === "certificateType") {
            setCertificateTypeValid(true);
        }

        if(name === "isValidTestReport") {
            setTestReportValid(true);
            setSamplingInitiatedByValid(true);
        }

        if(name === "samplingInitiatedBy") {
            setSamplingInitiatedByValid(true);
        }

        if(name === "inspectionStartDate") {
            setInspectionStartDateValid(true);
        }

        if(name === "inspectionEndtDate") {
            setInspectionEndDateValid(true);
        }

        if(name === "inspectionAddress") {
            setInspectionAddressValid(true);
        }

        if(name === "inspectionCountry") {
            setInspectionCountryValid(true);
        }

        if(name === "inspectionCity") {
            setInspectionCityValid(true);
        }

        if(name === "clientAddress") {
            setClientAddressValid(true);
        }

        if(name === "clientContact") {
            setClientContactValid(true);
        }

        if(name === "productLocation") {
            setProductLocationValid(true);
        }

        if(name === "requestSubType") {
            setRequestSubTypeValid(true);
        }

        if(name === "region") {
            setRegionValid(true);
        }

        if(name === "factoryAuditCategory") {
            setFactoryAuditCategoryValid(true);
        }

        if(name === "factoryAuditContactEmail") {
            if(value) {
                if(emailValidator.validate(value)) {
                    setFactoryAuditContactEmailValid(true);
                }
                else {
                    setFactoryAuditContactEmailValid(false);
                }
            }
            else {
                setFactoryAuditContactEmailValid(true);
            }
        }

        if(name === "factoryAuditReviewerUserEmail") {
            if(value) {
                if(emailValidator.validate(value)) {
                    setFactoryAuditReviewerEmailValid(true);
                }
                else {
                    setFactoryAuditReviewerEmailValid(false);
                }
            }
            else {
                setFactoryAuditReviewerEmailValid(true);
            }
        }

        if(name === "inspectionPersonEmail") {
            if(value) {
                if(emailValidator.validate(value)) {
                    setInspectionPersonEmailValid(true);
                }
                else {
                    setInspectionPersonEmailValid(false);
                }
            }
            else {
                setInspectionPersonEmailValid(true);
            }
        }

        if(name === "certificateIssueDate") {
            if(value) {
                if(fboState.ticket.isFactoryAudit) {
                    copy_fboState.ticket["certificateExpiryDate"] = getDateWithoutTimezone(new Date(moment(value).add(3,'y').subtract(1, 'days')));    
                }
                else {
                    copy_fboState.ticket["certificateExpiryDate"] = getDateWithoutTimezone(new Date(moment(value).add(1,'y').subtract(1, 'days')));
                }
            }
            else {
                copy_fboState.ticket["certificateExpiryDate"] = null;
            }

            copy_fboState.canViewCertificateLabel = false;
        }
        
        if(name === "inspectionStartDate") {
            if(value) {
                copy_fboState.ticket["inspectionEndDate"] = getDateWithoutTimezone(value);
                setInspectionEndDateValid(true);
            }
            else {
                copy_fboState.ticket["inspectionEndDate"] = null;
            }
        }
        
        setListPriceValid(true);
        setDiscountValid(true);
        setDiscountErrorMessage("");
        setCurrencyValid(true);
        setCustomerValid(true);
        setCrmNameValid(true);
        setCrmCountryValid(true);
        setSasoRequestNumberValid(true);
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectionAddressSelect = (locationData) => {
        if(locationData) {
            var copy_fboState = createDeepClone(fboState);

            copy_fboState.ticket["inspectionAddress"] = locationData.address;
            copy_fboState.ticket["inspectionCountry"] = locationData.country;
            copy_fboState.ticket["inspectionCity"] = locationData.city;
            copy_fboState.ticket["inspectionState"] = locationData.state;
            copy_fboState.ticket["inspectionZipCode"] = locationData.zipCode;
            copy_fboState.ticket["inspectionLatitude"] = locationData.latitude;
            copy_fboState.ticket["inspectionLongitude"] = locationData.longitude;

            setFBOState(copy_fboState);
            setIsDirty(true);
            setShowGoogleMap(false);
        }
    }

    const calculationTicketPricing = (copy_fboState) => {
        var quantity = copy_fboState.ticket["quantity"] || 0;
        var listPrice = copy_fboState.ticket["listPrice"] || 0;
        var listPriceTotal = 0;
        var discountType = copy_fboState.ticket["discountType"] || "Percentage";
        var discountValue = copy_fboState.ticket["discountValue"] || 0;
        var vatPercentage = copy_fboState.ticket["vatPercentage"] || 0;
        var discountAmount = 0;
        var salePrice = 0;
        var vat = 0;
        var price = 0;
        
        if(listPrice > 0) {
            listPriceTotal = (quantity * listPrice).toFixed(4);

            if(discountValue === 0) {
                discountAmount = 0;
            }
            else {
                if(discountType === "Percentage") {
                    discountAmount = ((discountValue/100) * listPriceTotal).toFixed(4);
                }
                else {
                    discountAmount = discountValue;
                }
            }

            salePrice = (listPriceTotal - discountAmount).toFixed(4);

            if(vatPercentage === 0) {
                vat = 0;
            }
            else {
                vat = ((vatPercentage/100) * salePrice).toFixed(4);
            }

            price = (parseFloat(salePrice) + parseFloat(vat)).toFixed(4);

            copy_fboState.ticket["listPriceTotal"] = listPriceTotal;
            copy_fboState.ticket["discountAmount"] = discountAmount;
            copy_fboState.ticket["salePrice"] = salePrice;
            copy_fboState.ticket["vat"] = vat;
            copy_fboState.ticket["price"] = price;
        }
        else {
            copy_fboState.ticket["listPriceTotal"] = 0;
            copy_fboState.ticket["discountAmount"] = 0;
            copy_fboState.ticket["salePrice"] = 0;
            copy_fboState.ticket["vat"] = 0;
            copy_fboState.ticket["price"] = 0;
        }

        return copy_fboState;
    }

    const onPcocNumberChange = (index, value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value) {
            copy_fboState.pcocNumbers[index] = value;
        }
        else {
            copy_fboState.pcocNumbers[index] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onPcocNumberAdd = (index) => {
        var copy_fboState = createDeepClone(fboState);
        
        copy_fboState.pcocNumbers.push("");
        
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onGroupChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["groupId"] = null;
            copy_fboState.ticket["groupUserId"] = null;
            copy_fboState.ticket["decisionUserId"] = null;
        }
        else {
            copy_fboState.ticket["groupId"] = value;
            copy_fboState.ticket["groupUserId"] = null;
            copy_fboState.ticket["decisionUserId"] = null;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onGroupUserChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["groupUserId"] = null;
        }
        else {
            if(copy_fboState.ticket["userIdAdded"] == value) {
                setShowGroupUserVsReporterSelectionError(true);
            }
            else if(copy_fboState.ticket["decisionUserId"] == value) {
                setShowGroupUserVsDecisionMakerSelectionError(true);
            }
            else {
                copy_fboState.ticket["groupUserId"] = value;
            }
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onDecisionMakerChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["decisionUserId"] = null;
        }
        else {
            if(fboState.ticket.isFactoryAuditAvailable) {
                if(copy_fboState.ticket["pdGroupUserId"] == value) {
                    setShowPdDecisionMakerVsGroupUserSelectionError(true);
                }
                else {
                    copy_fboState.ticket["decisionUserId"] = value;
                }
            }
            else {
                if(copy_fboState.ticket["userIdAdded"] == value) {
                    setShowDecisionMakerVsReporterSelectionError(true);
                }
                else if(copy_fboState.ticket["groupUserId"] == value) {
                    setShowDecisionMakerVsGroupUserSelectionError(true);
                }
                else {
                    copy_fboState.ticket["decisionUserId"] = value;
                }
            }
            
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onPdGroupChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["pdGroupId"] = null;
            copy_fboState.ticket["pdGroupUserId"] = null;
        }
        else {
            copy_fboState.ticket["pdGroupId"] = value;
            copy_fboState.ticket["pdGroupUserId"] = null;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onPdGroupUserChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["pdGroupUserId"] = null;
        }
        else {
            if(fboState.ticket.isFactoryAuditAvailable) {
                if(copy_fboState.ticket["decisionUserId"] == value) {
                    setShowPdGroupUserVsDecisionMakerSelectionError(true);
                }
                else {
                    copy_fboState.ticket["pdGroupUserId"] = value;
                }
            }
            else {
                copy_fboState.ticket["pdGroupUserId"] = value;
            }
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onDataReviewUserChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["dataReviewUserId"] = null;
        }
        else {
            copy_fboState.ticket["dataReviewUserId"] = value;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectionCoordinatorUserChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["inspectionCoordinatorUserId"] = null;
        }
        else {
            copy_fboState.ticket["inspectionCoordinatorUserId"] = value;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onSamplingUserChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.ticket["samplingUserId"] = null;
        }
        else {
            copy_fboState.ticket["samplingUserId"] = value;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onTechnicalRegulationChange = (items) => {
        if(items.length <= 5 || items.length <= selectedTechnicalRegulation.length) {
            setSelectedTechnicalRegulation(items);

            if(items.length > 0) {
                var ids = [];
                
                items.forEach(element => {
                    ids.push(element.description);
                });

                onTicketChange("technicalRegulation", ids.join("|"));
            }
            else {
                onTicketChange("technicalRegulation", null);
            }
        }
    }

    const onReporterChange = (items) => {
        setSelectedReporter(items);
        
        if(items.length > 0) {
            var ids = [];
            
            items.forEach(element => {
                ids.push(element.id);
            });

            onTicketChange("reporterUserId", ids.toString());
        }
        else {
            onTicketChange("reporterUserId", null);
        }
    }

    const onTagChange = (items) => {
        var copy_fboState = createDeepClone(fboState);

        if(items && items.length > 0) {
            var labels = [];
            var maxLength = 100;
            
            items.forEach(element => {
                if(element.label) {
                    if(element.label.length > maxLength) {
                        labels.push(element.label.substring(0, maxLength));
                        
                    }
                    else {
                        labels.push(element.label);
                    }
                }
                else {
                    if(element.length > maxLength) {
                        labels.push(element.substring(0, maxLength));
                    }
                    else {
                        labels.push(element);
                    }
                }                
            });

            copy_fboState.tagList = labels;
            setSelectedTag(labels);
        }
        else {
            copy_fboState.tagList = [];
            setSelectedTag([]);
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }
    
    const onCustomerChange = (item) => {
        setSelectedCustomer(item);
        
        if(item.length > 0) {
            onTicketChange("customerId", item[0].id.toString());
        }
        else {
            onTicketChange("customerId", null);
        }
    }

    const onManufacturerChange = (item) => {
        setSelectedManufacturer(item);
        var copy_fboState = createDeepClone(fboState);
        
        if(item.length > 0) {
            copy_fboState.ticket["manufacturerId"] = item[0].id.toString();
            
            if(fbo.ticket.isFactoryAudit) {
                copy_fboState.ticket["factoryAuditLocation"] = item[0].fullAddress;
                copy_fboState.ticket["factoryAuditContactName"] = item[0].contactName;
                copy_fboState.ticket["factoryAuditContactEmail"] = item[0].email;
                copy_fboState.ticket["factoryAuditContactPhone"] = item[0].telephoneNumber || item[0].mobileNumber;
            }
        }
        else {
            copy_fboState.ticket["manufacturerId"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onImporterChange = (item) => {
        setSelectedImporter(item);
        
        if(item.length > 0) {
            onTicketChange("importerId", item[0].id.toString());
        }
        else {
            onTicketChange("importerId", null);
        }
    }

    const onExporterChange = (item) => {
        setSelectedExporter(item);
        
        if(item.length > 0) {
            onTicketChange("exporterId", item[0].id.toString());
        }
        else {
            onTicketChange("exporterId", null);
        }
    }

    const onReviewerChange = (item) => {
        setSelectedReviewer(item);
        
        if(item.length > 0) {
            onTicketChange("factoryAuditReviewerUserId", item[0].id.toString());
        }
        else {
            onTicketChange("factoryAuditReviewerUserId", null);
        }
    }

    const onInspectorChange = (item) => {
        var copy_fboState = createDeepClone(fboState);
        setSelectedInspector(item);
                
        if(item.length > 0) {
            copy_fboState.ticket["inspectionUserId"] = item[0].id.toString();
            copy_fboState.ticket["inspectionUserType"] = item[0].userType;
        }
        else {
            copy_fboState.ticket["inspectionUserId"] = null;
            copy_fboState.ticket["inspectionUserType"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onSasoRequestNumberChange = (index, value) => {
        const sasoItems = selectedSasoRequestNumber.map((item, i) => {
            if (i === index) {
                return value;
            } else {
                return item;
            }
        });
        
        setSelectedSasoRequestNumber(sasoItems);
        
        var values = [];

        selectedSasoRequestNumber.forEach((element, i) => {
            if (i === index) {
                if(value) {
                    values.push(value);
                }
            }
            else {
                if(element) {
                    values.push(element);
                }    
            }
        });

        if(values.length > 0) {
            onTicketChange("sasoRequestNumber", values.toString());
        }
        else {
            onTicketChange("sasoRequestNumber", null);
        }
    }

    const getFactoryAuditTypeValue = (fieldValue) => {
        var value = false;

        if(fboState && fboState.ticket.factoryAuditType && fboState.ticket.factoryAuditType === fieldValue) {
            value = true;
        }

        return value;
    }

    const setFactoryAuditTypeValue = (fieldValue) => {
        if(fboState) {
            var copy_fboState = createDeepClone(fboState);

            copy_fboState.ticket.factoryAuditType = fieldValue;
            copy_fboState.ticket.factoryAuditSubType = null;

            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const getFactoryAuditSubTypeValue = (fieldValue, parentValue) => {
        var value = false;

        if(fboState && fboState.ticket.factoryAuditSubType && fboState.ticket.factoryAuditSubType === fieldValue && fboState.ticket.factoryAuditType === parentValue) {
            value = true;
        }

        return value;
    }

    const setFactoryAuditSubTypeValue = (fieldValue) => {
        if(fboState) {
            var copy_fboState = createDeepClone(fboState);

            copy_fboState.ticket.factoryAuditSubType = fieldValue;

            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const isValidFieldValue = (formName, fieldName, exactValue) => {
        var value = "";

        if(fboState && fboState[formName] && fboState[formName].canEdit === false) {
            return true;
        }

        if(fboState && fboState[formName] && fboState[formName].ticketFormData && fboState[formName].ticketFormData[fieldName] && fboState[formName].ticketFormData[fieldName].stringValue) {
            value = fboState[formName].ticketFormData[fieldName].stringValue;
        }

        if(exactValue && value && exactValue === value) {
            return true;
        }
        else if(value && !exactValue) {
            return true;
        }
        else if(fboState && fboState.ticket.status === "Data Review" && formName === "evaluationForm") {
            return true;
        }
        else {
            if(fieldName === "VerifyAccreditationBody" || fieldName === "VerifyAccreditationBodyText"
                || fieldName === "VerifyTestingLaboratory" || fieldName === "VerifyTestingLaboratoryText"
                || fieldName === "VerifyReportDate" || fieldName === "VerifyReportDateText"
            ) {
                if(getFieldValueText(formName, "TestReportDocument") === "No") {
                    return true;
                }
            }
        }

        return false;
    }

    const getFieldValue = (formName, fieldName, fieldValue) => {
        var value = "";

        if(fboState && fboState[formName] && fboState[formName].ticketFormData && fboState[formName].ticketFormData[fieldName] && fboState[formName].ticketFormData[fieldName].stringValue) {
            value = fboState[formName].ticketFormData[fieldName].stringValue;
        }

        if(value === fieldValue) {
            return true;
        }

        return false;
    }

    const setFieldValue = (formName, fieldName, fieldValue, fieldChecked, dependentFields) => {
        if(fboState && fboState.ticket.status === "Data Review" && formName === "evaluationForm" && fieldName === "InspectionApplicable") {
            return false;
        }

        if(fboState && fboState[formName] && fboState[formName].canEdit) {
            var copy_fboState = createDeepClone(fboState);

            if(copy_fboState && copy_fboState[formName] && copy_fboState[formName].ticketFormData && copy_fboState[formName].ticketFormData[fieldName]) {
                if(fieldChecked) {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = fieldValue;

                    if(dependentFields) {
                        if(fieldValue === "No" || fieldValue === "N/A") {
                            dependentFields.forEach(dependentField => {
                                if(copy_fboState[formName].ticketFormData[dependentField]) {
                                    copy_fboState[formName].ticketFormData[dependentField].stringValue = fieldValue;
                                }
                            });
                        }
                        else if(fieldValue == "Yes") {
                            dependentFields.forEach(dependentField => {
                                if(copy_fboState[formName].ticketFormData[dependentField]) {
                                    copy_fboState[formName].ticketFormData[dependentField].stringValue = "";
                                }
                            });
                        }
                    }
                }
                else {
                    if(copy_fboState[formName].ticketFormData[fieldName].field.fieldType === "Checkbox") {
                       copy_fboState[formName].ticketFormData[fieldName].stringValue = "No";    
                    }
                    else {
                       copy_fboState[formName].ticketFormData[fieldName].stringValue = "";
                    }
                }

                copy_fboState[formName].isModified = true;
    
                setFBOState(copy_fboState);
                setIsDirty(true);
            }
        }
    }

    const getFieldValueText = (formName, fieldName) => {
        var value = "";

        if(fboState && fboState[formName] && fboState[formName].ticketFormData && fboState[formName].ticketFormData[fieldName] && fboState[formName].ticketFormData[fieldName].stringValue) {
            value = fboState[formName].ticketFormData[fieldName].stringValue;
        }

        return value;
    }

    const setFieldValueText = (formName, fieldName, fieldValue) => {
        if(fboState && fboState[formName] && fboState[formName].canEdit) {
            var copy_fboState = createDeepClone(fboState);

            if(copy_fboState && copy_fboState[formName] && copy_fboState[formName].ticketFormData && copy_fboState[formName].ticketFormData[fieldName]) {
                if(fieldValue) {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = fieldValue;
                }
                else {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = "";
                }
            }
    
            copy_fboState[formName].isModified = true;
    
            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const setFieldValueNumber = (formName, fieldName, fieldValue) => {
        if(fboState && fboState[formName] && fboState[formName].canEdit) {
            var copy_fboState = createDeepClone(fboState);

            if(copy_fboState && copy_fboState[formName] && copy_fboState[formName].ticketFormData && copy_fboState[formName].ticketFormData[fieldName]) {
                if(fieldValue) {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = fieldValue.replace(/[^0-9]/g, '');
                }
                else {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = "";
                }
            }
    
            copy_fboState[formName].isModified = true;
    
            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const getFieldValueDate = (formName, fieldName) => {
        var value = "";

        if(fboState && fboState[formName] && fboState[formName].ticketFormData && fboState[formName].ticketFormData[fieldName] && fboState[formName].ticketFormData[fieldName].stringValue) {
            value = fboState[formName].ticketFormData[fieldName].stringValue;
        }

        if(value && value.length > 0) {
            try{
                return getFormattedDate(value);
            }
            catch(error) {
                return value;
            }
            
        }

        return value;
    }

    const setFieldValueDate = (formName, fieldName, fieldValue) => {
        if(fboState && fboState[formName] && fboState[formName].canEdit) {
            var copy_fboState = createDeepClone(fboState);

            if(copy_fboState && copy_fboState[formName] && copy_fboState[formName].ticketFormData && copy_fboState[formName].ticketFormData[fieldName]) {
                if(fieldValue) {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = getDateWithoutTimezone(fieldValue);
                }
                else {
                    copy_fboState[formName].ticketFormData[fieldName].stringValue = "";
                }
            }
    
            copy_fboState[formName].isModified = true;
    
            setFBOState(copy_fboState);
            setIsDirty(true);
        }
    }

    const onSaveTicket = async () => {
        var valid = true;
        
        if(valid) {
            if(fboState.ticket.factoryAuditContactEmail) {
                if(!emailValidator.validate(fboState.ticket.factoryAuditContactEmail)) {
                    dispatch(commonActions.setErrorMessage("Please input valid Contact Person Email."));
                    setFactoryAuditContactEmailValid(false);
                    valid = false;
                }
            }
        }

        if(valid) {
            if(fboState.ticket.factoryAuditReviewerUserType == "External" && fboState.ticket.factoryAuditReviewerUserEmail) {
                if(!emailValidator.validate(fboState.ticket.factoryAuditReviewerUserEmail)) {
                    dispatch(commonActions.setErrorMessage("Please input valid Reviewer Email."));
                    setFactoryAuditReviewerEmailValid(false);
                    valid = false;
                }
            }
        }

        if(valid) {
            if(fboState.ticket.inspectionPersonEmail) {
                if(!emailValidator.validate(fboState.ticket.inspectionPersonEmail)) {
                    dispatch(commonActions.setErrorMessage("Please input valid Inspection Person Email."));
                    setInspectionPersonEmailValid(false);
                    valid = false;
                }
            }
        }

        if(valid) {
            valid = await trigger();
            if(valid) {
                fboState.ticket.statusMessage = null;
                dispatch(ticketActions.saveTicket(fboState, selectedStatus, currentMessage, false, navigate));
            }
        }
        
        onCloseModalClick();
    }

    const onCancelTicket = () => {
        setFBOState(fbo);

        if(fbo.technicalRegulations != null) {
            setSelectedTechnicalRegulation(fbo.technicalRegulations);
        }
        else {
            setSelectedTechnicalRegulation([]);
        }

        if(fbo.reporter != null) {
            setSelectedReporter(fbo.reporter);
        }
        else {
            setSelectedReporter([]);
        }

        if(fbo.tagList != null) {
            setSelectedTag(fbo.tagList);
        }
        else {
            setSelectedTag([]);
        }
        
        if(fbo.customer != null) {
            setSelectedCustomer([fbo.customer]);
        }
        else {
            setSelectedCustomer([]);
        }

        if(fbo.manufacturer != null) {
            setSelectedManufacturer([fbo.manufacturer]);
        }
        else {
            setSelectedManufacturer([]);
        }

        if(fbo.importer != null) {
            setSelectedImporter([fbo.importer]);
        }
        else {
            setSelectedImporter([]);
        }

        if(fbo.exporter != null) {
            setSelectedExporter([fbo.exporter]);
        }
        else {
            setSelectedExporter([]);
        }

        if(fbo.reviewer != null) {
            setSelectedReviewer([fbo.reviewer]);
        }
        else {
            setSelectedReviewer([]);
        }

        if(fbo.inspector != null) {
            setSelectedInspector([fbo.inspector]);
        }
        else {
            setSelectedInspector([]);
        }

        var sasoItems = [];
        var sasoCounter = 0;

        if(fbo.ticket.sasoRequestNumber) {
            sasoCounter = 1;
            
            fbo.ticket.sasoRequestNumber.split(",").forEach(element => {
                sasoItems.push(element);
                sasoCounter += 1;
            });
        }

        while(sasoCounter < fbo.ticket.quantity) {
            sasoItems.push("");
            sasoCounter += 1;
        }

        setSelectedSasoRequestNumber(sasoItems);

        setIsDirty(false);
        clearErrors();
    }

    const onAssignMeTicket = async () => {
        dispatch(ticketActions.assignMeTicket(fboState.ticket.id, user.id, true, navigate));
        onCloseModalClick();
    }

    const onAssignMeTicketClick = () => {
        setShowAssignMeModal(true);
    }

    const validateProductCertificateStatusChange = (status) => {
        var valid = true;

        if(fboState.ticket.isProductCertificateAvailable && (status === "New" || status === "ReSubmit" || status === "In Progress" || status === "PD Review" || status === "Final Decision")) {
            if(!fboState.ticket.certificateType) {
                valid = false;
                dispatch(commonActions.setErrorMessage("Please select Request Type New/Renewal."));
                setCertificateTypeValid(false);
            }
            else if(!fboState.ticket.requestSubType) {
                valid = false;
                dispatch(commonActions.setErrorMessage("Please select type Type 1a/Type 3/Type 5."));
                setRequestSubTypeValid(false);
            }
            else if(!fboState.ticket.region) {
                valid = false;
                dispatch(commonActions.setErrorMessage("Please select Request Region."));
                setRegionValid(false);
            }
        }
        
        return valid;
    }

    const validateCosmeticStatusChange = (status) => {
        var valid = true;

        if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            if(!fboState.ticket.certificateType) {
                valid = false;
                dispatch(commonActions.setErrorMessage("Please select Request Type New/Renewal."));
                setCertificateTypeValid(false);
            }
            else  if(!fboState.ticket.isValidTestReport) {
                valid = false;
                dispatch(commonActions.setErrorMessage("Please select Test Report Yes/No."));
                setTestReportValid(false);
            }
            
            if(valid) {
                if(fboState.ticket.isValidTestReport === "Yes") {
                    if(!fboState.ticket.samplingInitiatedBy) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please Select Sampling Initiated By TUV Austria."));
                        setSamplingInitiatedByValid(false);
                    }
                }
                else if(fboState.ticket.isValidTestReport === "No") {
                    if(!fboState.ticket.clientAddress) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please input Client Address."));
                        setClientAddressValid(false);
                    }
                    else if(!fboState.ticket.clientContact) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please input Client Contact."));
                        setClientContactValid(false);
                    }
                    else if(!fboState.ticket.productLocation) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please input Product Location."));
                        setProductLocationValid(false);
                    }
                }
            }
            
            if(valid) {
                if(fboState.canEditInspectionInformation && getFieldValueText("reviewForm", "InspectionDetailProvided") === "Yes") {
                    if(!fboState.ticket.inspectionStartDate) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please select Inspection Start Date."));
                        setInspectionStartDateValid(false);
                    }
                    else if(!fboState.ticket.inspectionEndDate) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please select Inspection End Date."));
                        setInspectionEndDateValid(false);
                    }
                    else  if(!fboState.ticket.inspectionAddress) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please input Inspection Address."));
                        setInspectionAddressValid(false);
                    }
                    else  if(!fboState.ticket.inspectionCountry) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please input Inspection Country."));
                        setInspectionCountryValid(false);
                    }
                    else  if(!fboState.ticket.inspectionCity) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please input Inspection City."));
                        setInspectionCityValid(false);
                    }
                }
                else {
                    setInspectionStartDateValid(true);
                    setInspectionEndDateValid(true);
                    setInspectionAddressValid(true);
                    setInspectionCountryValid(true);
                    setInspectionCityValid(true);
                }                
            }
        }
        
        return valid;
    }

    const validateFactoryAuditStatusChange = (status) => {
        var valid = true;

        if(fboState.ticket.isFactoryAuditAvailable) {
            if(status === "Scheduled" || status === "Completed" || status === "Closed") {
                if(valid) {
                    if(!fboState.ticket.factoryAuditCategory) {
                        valid = false;
                        dispatch(commonActions.setErrorMessage("Please select Audit Type."));
                        setFactoryAuditCategoryValid(false);
                    }
                }
            }
        }

        return valid;
    }

    const onSubmitTicketClick = async () => {
        if(fboState.ticket.isProductCertificateAvailable) {
            var valid = validateProductCertificateStatusChange("New");

            if(valid) {            
                setLoadingLocal(true);
                var validationResult = await ticketActions.validateTicketSubmission(fboState, fboState.ticket.id);
                setLoadingLocal(false);
        
                if(validationResult.errorMessages.length > 0 || validationResult.warningMessages.length > 0) {
                    setErrorMessages(validationResult.errorMessages);
                    setWarningMessages(validationResult.warningMessages);
        
                    setSelectedStatus("New");
                    setCurrentMessage("");
                    setShowSubmitConfirmModal(true);
                }
                else {
                    setErrorMessages([]);
                    setWarningMessages([]);

                    setSelectedStatus("New");
                    setCurrentMessage("");
                    setShowSubmitModal(true);
                }
            }
        }
        else if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange();

            if(valid) {            
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("New");
                setCurrentMessage("");
                setShowSubmitModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("New");
            setCurrentMessage("");
            setShowSubmitModal(true);
        }
    }

    const onReSubmitTicketClick = async () => {
        if(fboState.ticket.isProductCertificateAvailable) {
            var valid = validateProductCertificateStatusChange("ReSubmit");

            if(valid) {
                setLoadingLocal(true);
                var validationResult = await ticketActions.validateTicketSubmission(fboState, fboState.ticket.id);
                setLoadingLocal(false);
        
                if(validationResult.errorMessages.length > 0) {
                    setErrorMessages(validationResult.errorMessages);
                    setWarningMessages([]);
        
                    setSelectedStatus("ReSubmit");
                    setCurrentMessage("");
                    setShowSubmitConfirmModal(true);
                }
                else {
                    setErrorMessages([]);
                    setWarningMessages([]);

                    setSelectedStatus("ReSubmit");
                    setCurrentMessage("");
                    setShowReSubmitModal(true);
                }
            }
        }
        else if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange("ReSubmit");

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("ReSubmit");
                setCurrentMessage("");
                setShowReSubmitModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("ReSubmit");
            setCurrentMessage("");
            setShowReSubmitModal(true);
        }
    }

    const onInProgressTicketClick = async () => {
        if(fboState.ticket.isProductCertificateAvailable) {
            var valid = validateProductCertificateStatusChange("In Progress");

            if(valid) {
                setLoadingLocal(true);
                var validationResult = await ticketActions.validateTicketSubmission(fboState, fboState.ticket.id);
                setLoadingLocal(false);
        
                if(validationResult.errorMessages.length > 0) {
                    setErrorMessages(validationResult.errorMessages);
                    setWarningMessages([]);
        
                    setSelectedStatus("In Progress");
                    setCurrentMessage("");
                    setShowSubmitConfirmModal(true);
                }
                else {
                    setErrorMessages([]);
                    setWarningMessages([]);

                    setSelectedStatus("In Progress");
                    setCurrentMessage("");
                    setShowInProgressModal(true);
                }
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("In Progress");
            setCurrentMessage("");
            setShowInProgressModal(true);
        }
    }

    const onAcceptTicketClick = () => {
        setSelectedStatus("Accept");
        setCurrentMessage("");
        setShowAcceptModal(true);
    }

    const onRejectTicketClick = () => {
        setSelectedStatus("Reject");
        setCurrentMessage("");
        setShowRejectModal(true);
    }

    const onSalesActionTicketClick = () => {
        setSelectedStatus("Sales Action");
        setCurrentMessage("");
        setShowSalesActionModal(true);
    }

    const onPdReviewTicketClick = async () => {
        if(fboState.ticket.isProductCertificateAvailable) {
            var valid = validateProductCertificateStatusChange("PD Review")

            if(valid) {
                setLoadingLocal(true);
                var validationResult = await ticketActions.validateTicketSubmission(fboState, fboState.ticket.id);
                setLoadingLocal(false);
        
                if(validationResult.errorMessages.length > 0) {
                    setErrorMessages(validationResult.errorMessages);
                    setWarningMessages([]);
        
                    setSelectedStatus("PD Review");
                    setCurrentMessage("");
                    setShowSubmitConfirmModal(true);
                }
                else {
                    setErrorMessages([]);
                    setWarningMessages([]);

                    setSelectedStatus("PD Review");
                    setCurrentMessage("");
                    setShowPdReviewModal(true);
                }
            }
        }
        else if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange()

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("PD Review");
                setCurrentMessage("");
                setShowPdReviewModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("PD Review");
            setCurrentMessage("");
            setShowPdReviewModal(true);
        }
    }

    const onTechnicalReviewTicketClick = async () => {
        if(fboState.ticket.isProductCertificateAvailable) {
            var valid = validateProductCertificateStatusChange("Technical Review")

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Technical Review");
                setCurrentMessage("");
                setShowTechnicalReviewModal(true);
            }
        }
        else if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange()

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Technical Review");
                setCurrentMessage("");
                setShowTechnicalReviewModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Technical Review");
            setCurrentMessage("");
            setShowTechnicalReviewModal(true);
        }
    }

    const onTechnicalSupportTicketClick = async () => {
        if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange()

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Technical Support");
                setCurrentMessage("");
                setShowTechnicalSupportModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Technical Support");
            setCurrentMessage("");
            setShowTechnicalSupportModal(true);
        }
    }

    const onApprovePdTicketClick = () => {
        setSelectedStatus("ApprovePd");
        setCurrentMessage("");
        setShowApprovePdModal(true);
    }

    const onRejectPdTicketClick = () => {
        setSelectedStatus("RejectPd");
        setCurrentMessage("");
        setShowRejectPdModal(true);
    }

    const onFinalDecisionTicketClick = () => {
        if(fboState.ticket.isProductCertificateAvailable) {
            var valid = validateProductCertificateStatusChange("Final Decision")

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Final Decision");
                setCurrentMessage("");
                setShowFinalDecisionModal(true);
            }
        }
        else if(fboState.ticket.isFactoryAuditAvailable) {
            var valid = validateFactoryAuditStatusChange("Final Decision")

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Final Decision");
                setCurrentMessage("");
                setShowFinalDecisionModal(true);
            }
        }
        else if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange()

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Final Decision");
                setCurrentMessage("");
                setShowFinalDecisionModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Final Decision");
            setCurrentMessage("");
            setShowFinalDecisionModal(true);
        }
    }

    const onReadyToIssueTicketClick = () => {
        if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange()

            if(valid) {
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Ready To Issue");
                setCurrentMessage("");
                setShowReadyToIssueModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Ready To Issue");
            setCurrentMessage("");
            setShowReadyToIssueModal(true);
        }
    }

    const onScheduledTicketClick = () => {
        if(fbo.ticket.isFactoryAuditAvailable) {
            var valid = validateFactoryAuditStatusChange("Scheduled");
            
            if(valid) {
                setSelectedStatus("Scheduled");
                setCurrentMessage("");
                setShowScheduledModal(true);
            }
        }
        else {
            setSelectedStatus("Scheduled");
            setCurrentMessage("");
            setShowScheduledModal(true);
        }
    }

    const onWaitingCorrectiveActionTicketClick = () => {
        setSelectedStatus("Waiting Corrective Action");
        setCurrentMessage("");
        setShowWaitingCorrectiveActionModal(true);
    }

    const onDataReviewTicketClick = () => {
        if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange();

            if(valid) {            
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Data Review");
                setCurrentMessage("");
                setShowDataReviewModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Data Review");
            setCurrentMessage("");
            setShowDataReviewModal(true);
        }
    }

    const onPhase1EvaluationTicketClick = () => {
        if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange();

            if(valid) {            
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Phase 1 Evaluation");
                setCurrentMessage("");
                setShowPhase1EvaluationModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Phase 1 Evaluation");
            setCurrentMessage("");
            setShowPhase1EvaluationModal(true);
        }
    }

    const onPhase2EvaluationTicketClick = () => {
        if(fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) {
            var valid = validateCosmeticStatusChange();

            if(valid) {            
                setErrorMessages([]);
                setWarningMessages([]);

                setSelectedStatus("Phase 2 Evaluation");
                setCurrentMessage("");
                setShowPhase2EvaluationModal(true);
            }
        }
        else {
            setErrorMessages([]);
            setWarningMessages([]);

            setSelectedStatus("Phase 2 Evaluation");
            setCurrentMessage("");
            setShowPhase2EvaluationModal(true);
        }
    }

    const onStoppedTicketClick = () => {
        setSelectedStatus("Stopped");
        setCurrentMessage("");
        setShowStoppedModal(true);
    }

    const onAbortTicketClick = () => {
        setSelectedStatus("Aborted");
        setCurrentMessage("");
        setShowAbortModal(true);
    }

    const onCompleteTicketClick = () => {
        setSelectedStatus("Completed");
        setCurrentMessage("");
        setShowCompleteModal(true);
    }

    const onCloseTicketClick = () => {
        setSelectedStatus("Closed");
        setCurrentMessage("");
        setShowCloseModal(true);
    }

    const onCancelTicketClick = () => {
        setSelectedStatus("Cancelled");
        setCurrentMessage("");
        setShowCancelModal(true);
    }

    const onNonConformityTicketClick = () => {
        setSelectedStatus("Non Conformity");
        setCurrentMessage("");
        setShowNonConformityModal(true);
    }

    const onAcceptNonConformityTicketClick = () => {
        setSelectedStatus("AcceptNonConformity");
        setCurrentMessage("");
        setShowAcceptNonConformityModal(true);
    }

    const onRejectNonConformityTicketClick = () => {
        setSelectedStatus("RejectNonConformity");
        setCurrentMessage("");
        setShowRejectNonConformityModal(true);
    }

    const onResetToDraftTicketClick = () => {
        setSelectedStatus("Draft");
        setCurrentMessage("");
        setShowResetToDraftModal(true);
    }

    const onResetToSamplingInProcessTicketClick = () => {
        setSelectedStatus("Sampling In Process");
        setCurrentMessage("");
        setShowResetToSamplingInProcessModal(true);
    }

    const onResetToInspectionInProcessTicketClick = () => {
        setSelectedStatus("Inspection In Process");
        setCurrentMessage("");
        setShowResetToInspectionInProcessModal(true);
    }

    const onCloseModalClick = () => {
        setSelectedStatus("");
        setCurrentMessage("");

        setShowAssignMeModal(false);
        setShowSubmitModal(false);
        setShowSubmitConfirmModal(false);
        setShowReSubmitModal(false);
        setShowInProgressModal(false);
        setShowAcceptModal(false);
        setShowRejectModal(false);
        setShowSalesActionModal(false);
        setShowPdReviewModal(false);
        setShowTechnicalReviewModal(false);
        setShowTechnicalSupportModal(false);
        setShowApprovePdModal(false);
        setShowRejectPdModal(false);
        setShowFinalDecisionModal(false);
        setShowReadyToIssueModal(false);
        setShowScheduledModal(false);
        setShowWaitingCorrectiveActionModal(false);
        setShowDataReviewModal(false);
        setShowPhase1EvaluationModal(false);
        setShowPhase2EvaluationModal(false);
        setShowStoppedModal(false);
        setShowAbortModal(false);
        setShowCompleteModal(false);
        setShowCloseModal(false);
        setShowCancelModal(false);
        setShowNonConformityModal(false);
        setShowAcceptNonConformityModal(false);
        setShowRejectNonConformityModal(false);
        setShowResetToDraftModal(false);
        setShowResetToSamplingInProcessModal(false);
        setShowResetToInspectionInProcessModal(false);
        setShowNotifyCreateInvoiceModal(false);
        setShowNotifySadadPaymentModal(false);
        setShowNotifySadadPaidModal(false);
        setShowNCRModal(false);
        setShowVerifiedModal(false);
        setShowRemoveInvoiceModal(false);
        setShowAutoCloseModal(false);
    }

    const onNotifyInvoiceCreation = async () => {
        setShowNotifyCreateInvoiceModal(true);
    }

    const onSaveNotifyInvoiceCreation = async () => {
        setShowNotifyCreateInvoiceModal(false);

        setLoadingLocal(true);
        var data = await ticketActions.addTicketCreateInvoiceNotification(fboState.ticket.id);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }
    }

    const onNotifySADADPayment = async () => {
        setShowNotifySadadPaymentModal(true);
    }

    const onSaveNotifySADADPayment = async () => {
        setShowNotifySadadPaymentModal(false);

        setLoadingLocal(true);
        var data = await ticketActions.addTicketSadadPaymentNotification(fboState.ticket.id);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }
    }

    const onNotifySADADPaid = async () => {
        setShowNotifySadadPaidModal(true);
    }

    const onSaveNotifySADADPaid = async () => {
        setShowNotifySadadPaidModal(false);

        setLoadingLocal(true);
        var data = await ticketActions.addTicketSadadPaidNotification(fboState.ticket.id);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }
    }

    const onNCR = async () => {
        setShowNCRModal(true);
    }

    const onSaveNCR = async () => {
        setShowNCRModal(false);

        setLoadingLocal(true);
        var data = await ticketActions.updateTicketComplianceState(fboState.ticket.id, "NCR", currentMessage);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onVerified = async () => {
        setShowVerifiedModal(true);
    }

    const onSaveVerified = async () => {
        setShowVerifiedModal(false);

        setLoadingLocal(true);
        var data = await ticketActions.updateTicketComplianceState(fboState.ticket.id, "Verified", currentMessage);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onRemoveInvoice = async () => {
        setShowRemoveInvoiceModal(true);
    }

    const onSaveRemoveInvoice = async () => {
        setShowRemoveInvoiceModal(false);

        setLoadingLocal(true);
        var data = await ticketActions.removeTicketInvoice(fboState.ticket.id);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const validateTicketAutoClose = async (fbo) => {
        if(autoCloseShown === false && fbo.canClose && (fbo.ticket.status === "Sampling In Process" || fbo.ticket.status === "Inspection In Process" || fbo.ticket.status === "Completed")) {
            var validationResult = await ticketActions.validateTicketAutoClose(fbo, fbo.ticket.id);
            if(validationResult && validationResult.success === true) {
                setSelectedStatus("Closed");
                setCurrentMessage("");
                setShowAutoCloseModal(true);

                setAutoCloseShown(true);
            }
        }
    }

    const onCreateInvoice = async () => {
        if(fboState.ticket.lineId) {
            setShowInvoiceError(true);
        }
        else {
            setListPriceValid(true);
            setDiscountValid(true);
            setDiscountErrorMessage("");
            setCurrencyValid(true);
            setCustomerValid(true);
            setCrmNameValid(true);
            setCrmCountryValid(true);
            setSasoRequestNumberValid(true);

            setShowInvoiceCreateModal(true);
        }
    }

    const hideInvoiceCreateModal = async () => {
        setShowInvoiceCreateModal(false);
    }

    const onSaveCreateInvoice = async (saveOnly) => {        
        var valid = true;
        
        var listPrice = fboState.ticket["listPrice"] || 0;
        var discountValue = fboState.ticket["discountValue"] || 0;
        var discountType = fboState.ticket["discountType"] || "Percentage";
        var currency = fboState.ticket["currency"] || 0;
        var customerId = fboState.ticket["customerId"] || 0;
        var crmName = fboState.ticket["crmName"] || 0;
        var crmCountry = fboState.ticket["crmCountry"] || 0;

        if(listPrice === 0) {
            valid = false;
            setListPriceValid(false);
        }
        else {
            setListPriceValid(true);
        }

        if(discountValue > 0) {
            if(discountType === "Percentage" && discountValue > 100) {
                valid = false;
                setDiscountValid(false);
                setDiscountErrorMessage("Please enter a discount percentage between 0% and 100%");
            }
            else if(discountValue > listPrice) {
                valid = false;
                setDiscountValid(false);
                setDiscountErrorMessage("Discount amount must be less than or equal to the list price.");
            }
            else {
                setDiscountValid(true);
                setDiscountErrorMessage("");
            }
        }

        if(currency === 0) {
            valid = false;
            setCurrencyValid(false);
        }
        else {
            setCurrencyValid(true);
        }

        if(customerId === 0) {
            valid = false;
            setCustomerValid(false);
        }
        else {
            setCustomerValid(true);
        }

        if(crmName === 0) {
            valid = false;
            setCrmNameValid(false);
        }
        else {
            setCrmNameValid(true);
        }

        if(crmCountry === 0) {
            valid = false;
            setCrmCountryValid(false);
        }
        else {
            setCrmCountryValid(true);
        }

        setSasoRequestNumberValid(true);

        if(fboState && fboState.ticket.isProductCertificate) {
            selectedSasoRequestNumber.forEach((element, i) => {
                if (element && element.length > 0) {
                    //do nothing
                }
                else {
                    valid = false;
                    setSasoRequestNumberValid(false);
                }
            });
        }

        if(valid) {
            if(saveOnly) {
                dispatch(ticketActions.saveTicket(fboState, selectedStatus, currentMessage, false, navigate));
            }
            else{
                if(isDirty) {
                    dispatch(ticketActions.saveTicket(fboState, selectedStatus, currentMessage, true, navigate));
                }
                else {
                    dispatch(ticketActions.createInvoice(fboState.ticket.id, navigate));
                }
            }
        }
    }

    const onViewInvoice = async () => {
        dispatch(ticketActions.viewInvoice(fboState.ticket.id, navigate));
        setShowInvoiceViewModal(true);
    }

    const hideInvoiceViewModal = async () => {
        setShowInvoiceViewModal(false);
    }

    const onViewContract = async () => {
        if(fboState && fboState.ticket.customerId && fboState.ticket.serviceId) {
            dispatch(ticketActions.loadTicketInvoiceContract(fboState.ticket.crmName, fboState.ticket.customerId, fboState.ticket.serviceId));
            dispatch(ticketActions.loadTicketInvoiceProduct(fboState.ticket.crmName, fboState.ticket.customerId, fboState.ticket.serviceId, productNameQuery));
            setShowContractModal(true);
        }
        else {
            setShowCustomerError(true);
        }
    }

    const hideContractModal = async () => {
        setShowContractModal(false);
    }

    const onSearchInvoiceProduct = async () => {
        dispatch(ticketActions.loadTicketInvoiceProduct(fboState.ticket.crmName, fboState.ticket.customerId, fboState.ticket.serviceId, productNameQuery));
    }

    const onContractSelect = (item) => {
        if(item) {
            var copy_fboState = createDeepClone(fboState);
            copy_fboState.ticket["productId"] = item.productId;
            copy_fboState.ticket["productType"] = item.productType;
            copy_fboState.ticket["productName"] = item.productName;
            copy_fboState.ticket["productDescription"] = item.productDescription;
            copy_fboState.ticket["currency"] = item.currency;
            copy_fboState.ticket["listPrice"] = item.listPrice;
            copy_fboState.ticket["discountValue"] = item.discountValue;
            copy_fboState.ticket["discountType"] = item.discountType;
            copy_fboState.ticket["vatPercentage"] = item.vatPercentage;

            copy_fboState = calculationTicketPricing(copy_fboState);

            setFBOState(copy_fboState);
            setIsDirty(true);
        }

        hideContractModal();
    }

    const onCreateSampling = async () => {
        setShowCreateSamplingModal(true);
    }

    const hideCreateSamplingModal = async () => {
        setShowCreateSamplingModal(false);
    }

    const onSaveCreateSampling = async () => {        
        setShowCreateSamplingModal(false);

        setLoadingLocal(true);
        var error = await ticketActions.createSamplingTicket(fboState.ticket.id);
        setLoadingLocal(false);

        if(error) {
            dispatch(commonActions.setErrorMessage(error));
        }
        else {
            dispatch(commonActions.setSuccessMessage("Sampling Created Successfully!"));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
    }

    const onCreateInspection = async () => {
        setShowCreateInspectionModal(true);
    }

    const hideCreateInspectionModal = async () => {
        setShowCreateInspectionModal(false);
    }

    const onSaveCreateInspection = async () => {        
        setShowCreateInspectionModal(false);

        setLoadingLocal(true);
        var error = await ticketActions.createInspectionTicket(fboState.ticket.id);
        setLoadingLocal(false);

        if(error) {
            dispatch(commonActions.setErrorMessage(error));
        }
        else {
            dispatch(commonActions.setSuccessMessage("Inspection Created Successfully!"));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
    }

    const onApproveFormReviewSFDAModal = async () => {
        if(approverFormReviewSFDA > 0) {
            setShowApproveFormReviewSFDAModal(true);
        }
        else {
            dispatch(commonActions.setErrorMessage("Please select Technical Reviewer for Inspection Operation."));
        }
    }

    const hideApproveFormReviewSFDAModal = async () => {
        setShowApproveFormReviewSFDAModal(false);
    }

    const onSaveApproveFormReviewSFDA = async () => {        
        setShowApproveFormReviewSFDAModal(false);

        setLoadingLocal(true);
        var error = await ticketActions.approvedTicketForm(fboState.reviewForm.ticketForm.id, fboState.ticket.id, approverFormReviewSFDA);
        setLoadingLocal(false);

        if(error) {
            dispatch(commonActions.setErrorMessage(error));
        }
        else {
            dispatch(commonActions.setSuccessMessage("Application Review Form Approved Successfully!"));
            dispatch(ticketActions.loadTicket(fboState.ticket.id, navigate));
        }
    }

    const onViewVendorForm = async (type) => {
        setVendorFormType(type);
        setShowVendorFormModal(true);
    }

    const hideVendorFormModal = async (vendor) => {
        setShowVendorFormModal(false);
        if(vendor) {
            if(vendorFormType === "manufacturer") {
                setSelectedManufacturer([vendor]);
                onManufacturerChange([vendor]);
            }
            else if(vendorFormType === "importer") {
                setSelectedImporter([vendor]);
                onImporterChange([vendor]);
            }
            else if(vendorFormType === "exporter") {
                setSelectedExporter([vendor]);
                onExporterChange([vendor]);
            }
        }
    }

    const UserRenderer = (results, menuProps, props) => (
        <Menu id="menuUserLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Name</div>
                    <div className="col">Email</div>
                    <div className="col">Employee ID</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullName || ''}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ''}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.employeeId || ''}
                            </Highlighter>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    const VendorRenderer = (results, menuProps, props) => (
        <Menu id="menuVendorLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Organization Name</div>
                    <div className="col">Contact Name</div>
                    <div className="col">Email</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.organizationName || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.contactName || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ""}
                            </Highlighter>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    const InspectorRenderer = (results, menuProps, props) => (
        <Menu id="menuInspectorLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Inspector Name</div>
                    <div className="col">Email</div>
                    <div className="col">Emp ID #</div>
                    <div className="col">Distance</div>
                    <div className="col" style={{textAlign:"right"}}>View Calendar</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullName || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.employeeId || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <MyNumberRenderer value={result.distanceKm || ""} /> {result.distanceKm ? "KM" : ""}
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <a
                                className="btn btn-outline-primary btn-icon float-end btn-sm"
                                title="View Inspector Calendar"
                                style={{marginBottom:5}}
                                target="_blank"
                                href={`/request-calendar/${result.id}`}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <i className="ri-calendar-line"></i>
                            </a>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={`Edit Ticket ${isContainer ? "Container" : ""}`} />
                    <Row>
                        <Col lg={user && user.isExternalAudit && !showLinkedTickets() ? 12 : 9}>
                            <Card className="mb-0">
                                <CardLoader loading={loading || loadingLocal} />

                                <CardBody style={{margin:0, padding:0}}>
                                    <Card className="mb-0">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">
                                                Ticket {isContainer ? "Container" : ""}
                                                {fboState && fboState.ticket.ticketType === "CHILD" && 
                                                <span style={{fontSize:"70%"}} className="ms-1">
                                                    <Link to={`/request-edit/${fboState && fboState.ticket.parentId}`}>
                                                        (view container)
                                                    </Link>
                                                </span>
                                                }
                                                {fboState && fboState.ticket.pdApproved === true && <span><img src={logoApproved} alt="" height="50" title="PD Approved" /></span>}
                                                {fboState && fboState.ticket.pdApproved === false && <span><img src={logoRejected} alt="" height="50" title="PD Rejected" /></span>}
                                                <ComplianceLabel value={fboState && fboState.ticket.complianceState || ""} />
                                                <NonConformityLabel value={fboState && fboState.ticket.inspectionNCStateResult || ""} />
                                            </h5>
                                            <div className="flex-shrink-1 ms-3">
                                                <div className="d-flex flex-wrap gap-1">
                                                    {fboState && (fboState.canSave || fboState.canUpdateInspectionDate) &&
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal || !isDirty}
                                                        onClick={() => onSaveTicket()}
                                                    >
                                                        <i className="ri-save-line label-icon align-bottom"></i> Save Ticket {isContainer ? "Container" : ""}
                                                    </button>
                                                    }
                                                    {fboState && (fboState.canSave || fboState.canUpdateInspectionDate) &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal || !isDirty}
                                                        onClick={() => onCancelTicket()}
                                                    >
                                                        <i className="ri-close-line label-icon align-bottom"></i> Cancel
                                                    </button>
                                                    }
                                                    {fboState && fboState.canAssignMe &&
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onAssignMeTicketClick()}
                                                    >
                                                        <i className="ri-user-follow-line label-icon align-bottom"></i> Assign Me Ticket {isContainer ? "Container" : ""}
                                                    </button>
                                                    }
                                                    {fboState && fboState.canSubmit &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onSubmitTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Submit
                                                    </button>
                                                    }
                                                    {fboState && fboState.canReSubmit &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onReSubmitTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Re-Submit
                                                    </button>
                                                    }
                                                    {fboState && fboState.canInProgress &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onInProgressTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Send to {fboState && fboState.ticket.isFactoryAuditAvailable ? "PD" : "Technical"}
                                                    </button>
                                                    }
                                                    {fboState && fboState.canAccept &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onAcceptTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Accept
                                                    </button>
                                                    }
                                                    {fboState && fboState.canReject &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onRejectTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Reject
                                                    </button>
                                                    }
                                                    {fboState && fboState.canSalesAction &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onSalesActionTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Sales Action
                                                    </button>
                                                    }
                                                    {fboState && fboState.canPdReview &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onPdReviewTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> PD Review
                                                    </button>
                                                    }
                                                    {fboState && fboState.canTechnicalReview &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onTechnicalReviewTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Technical Review
                                                    </button>
                                                    }
                                                    {fboState && fboState.canTechnicalSupport &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onTechnicalSupportTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Technical Support
                                                    </button>
                                                    }
                                                    {fboState && fboState.canApprovePd &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onApprovePdTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> PD Approved
                                                    </button>
                                                    }
                                                    {fboState && fboState.canRejectPd &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onRejectPdTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> PD Rejected
                                                    </button>
                                                    }
                                                    {fboState && fboState.canCreateSampling &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCreateSampling()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Initiate Sampling
                                                    </button>
                                                    }
                                                    {fboState && fboState.canScheduled && fboState.ticket.factoryAuditSubType !== "None" &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onScheduledTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Schedule
                                                    </button>
                                                    }
                                                    {fboState && fboState.canWaitingCorrectiveAction &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onWaitingCorrectiveActionTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Waiting Corrective Action
                                                    </button>
                                                    }
                                                    {fboState && fboState.canDataReview &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onDataReviewTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Data Review
                                                    </button>
                                                    }
                                                    {fboState && fboState.canPhase1Evaluation &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onPhase1EvaluationTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Phase 1 Evaluation
                                                    </button>
                                                    }
                                                    {fboState && fboState.canCreateInspection &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCreateInspection()}
                                                    >
                                                        <i className="ri-add-line label-icon align-bottom"></i> Initiate Inspection
                                                    </button>
                                                    }
                                                    {fboState && fboState.canPhase2Evaluation &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onPhase2EvaluationTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Phase 2 Evaluation
                                                    </button>
                                                    }
                                                    {fboState && fboState.canFinalDecision &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onFinalDecisionTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Final Decision
                                                    </button>
                                                    }
                                                    {fboState && fboState.canReadyToIssue &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onReadyToIssueTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Ready To Issue
                                                    </button>
                                                    }
                                                    {fboState && fboState.canNonConformity &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onNonConformityTicketClick()}
                                                    >
                                                        <i className="ri-add-line label-icon align-bottom"></i> Start Non Conformity
                                                    </button>
                                                    }
                                                    {fboState && fboState.canAcceptNonConformity &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onAcceptNonConformityTicketClick()}
                                                    >
                                                        <i className="ri-add-line label-icon align-bottom"></i> Accept Non Conformity
                                                    </button>
                                                    }
                                                    {fboState && fboState.canRejectNonConformity &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onRejectNonConformityTicketClick()}
                                                    >
                                                        <i className="ri-add-line label-icon align-bottom"></i> Reject Non Conformity
                                                    </button>
                                                    }
                                                    {fboState && fboState.canComplete &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCompleteTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Complete
                                                    </button>
                                                    }
                                                    {fboState && fboState.canClose &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCloseTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Close
                                                    </button>
                                                    }
                                                    {fboState && fboState.canScheduled && fboState.ticket.factoryAuditSubType === "None" &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCloseTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Close
                                                    </button>
                                                    }
                                                    {fboState && fboState.canCancel &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCancelTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Cancel / Suspend Certificate
                                                    </button>
                                                    }
                                                    {fboState && fboState.canStop &&
                                                    <button className="btn btn-danger btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onStoppedTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Stop
                                                    </button>
                                                    }
                                                    {fboState && fboState.canAbort &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onAbortTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Abort
                                                    </button>
                                                    }
                                                    {fboState && fboState.canResetToDraft &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onResetToDraftTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Reset To Draft
                                                    </button>
                                                    }
                                                    {fboState && fboState.canResetToSamplingInProcess &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onResetToSamplingInProcessTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Reset To Sampling In Process
                                                    </button>
                                                    }
                                                    {fboState && fboState.canResetToInspectionInProcess &&
                                                    <button className="btn btn-secondary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onResetToInspectionInProcessTicketClick()}
                                                    >
                                                        <i className="ri-check-double-line label-icon align-bottom"></i> Reset To Inspection In Process
                                                    </button>
                                                    }
                                                    {fboState && fboState.canNotifyInvoice && 
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onNotifyInvoiceCreation()}
                                                    >
                                                        <i className="ri-notification-line label-icon align-bottom"></i> Send invoice Reminder
                                                    </button>
                                                    }
                                                    {fboState && fboState.canNotifySadad && 
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onNotifySADADPayment()}
                                                    >
                                                        <i className="ri-notification-line label-icon align-bottom"></i> Pay SADAD
                                                    </button>
                                                    }
                                                    {fboState && fboState.canSadadPaid && 
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onNotifySADADPaid()}
                                                    >
                                                        <i className="ri-notification-line label-icon align-bottom"></i> SADAD Paid
                                                    </button>
                                                    }
                                                    {fboState && fboState.canNCR && 
                                                    <button className="btn btn-dark btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onNCR()}
                                                    >
                                                        <i style={{color:"red"}} className="bx bxs-badge-check label-icon align-bottom"></i> NCR
                                                    </button>
                                                    }
                                                    {fboState && fboState.canVerified && 
                                                    <button className="btn btn-dark btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onVerified()}
                                                    >
                                                        <i style={{color:"green"}} className="bx bxs-badge-check label-icon align-bottom"></i> Verified
                                                    </button>
                                                    }
                                                    {fboState && fboState.canCreateInvoice && 
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onCreateInvoice()}
                                                    >
                                                        <i className="ri-add-line label-icon align-bottom"></i> Create Invoice
                                                    </button>
                                                    }
                                                    {fboState && fboState.canRemoveInvoice && 
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onRemoveInvoice()}
                                                    >
                                                        <i className="ri-add-line label-icon align-bottom"></i> Remove Invoice
                                                    </button>
                                                    }
                                                    {fboState && fboState.canViewInvoice &&
                                                    <button className="btn btn-primary btn-label"
                                                        disabled={loading || loadingLocal}
                                                        onClick={() => onViewInvoice()}
                                                    >
                                                        <i className="ri-bill-line label-icon align-bottom"></i> View Invoice
                                                    </button>
                                                    }
                                                    
                                                </div>
                                            </div>
                                        </CardHeader>
                                                                                
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                {fboState && fboState.ticket.isProductCertificateAvailable &&
                                                <Col xxl={12} md={12}>
                                                    <div className="d-flex align-items-right">
                                                        <div className="flex-grow-1">
                                                            <div className="form-check pt-2">
                                                                <div className="d-flex">
                                                                    <span className="pe-5">
                                                                        <input type="radio" className="form-check-input" disabled={true}
                                                                            checked={(fboState && fboState.ticket.productAllowed === "Single")}
                                                                            onChange={e => onTicketChange("productAllowed", "Single")}
                                                                        /> Single(P) Request
                                                                    </span>
                                                                    <span className="pe-5">
                                                                        <input type="radio" className="form-check-input" disabled={true}
                                                                            checked={(fboState && fboState.ticket.productAllowed === "Multiple")}
                                                                            onChange={e => onTicketChange("productAllowed", "Multiple")}
                                                                        /> Category Request
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flex-shrink-0">
                                                            {fboState && fboState.sadadLabel &&
                                                            <span className={`badge ${fboState.sadadLabel === "SADAD PENDING" ? "bg-danger" : "bg-success"}`} style={{padding:10}}>{fboState && fboState.sadadLabel} {fboState && fboState.sadadTime}</span>
                                                            }
                                                            {fboState && fboState.inspectionNCStateResult}
                                                            {fboState && fboState.inspectionNCStateResult === "NC Accepted" &&
                                                            <span className="badge bg-success" style={{padding:10}}>{fboState && fboState.inspectionNCStateResult}</span>
                                                            }
                                                            {fboState && fboState.inspectionNCStateResult === "NC Rejected" &&
                                                            <span className="badge bg-danger" style={{padding:10}}>{fboState && fboState.inspectionNCStateResult}</span>
                                                            }
                                                            {fboState && fboState.inspectionNCStateResult === "NC Pending" &&
                                                            <span className="badge bg-warning" style={{padding:10}}>{fboState && fboState.inspectionNCStateResult} : {getFormattedDate(fboState.ticket.inspectionNCEndDate) || ""}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                                }
                                                {fboState && fboState.ticket.isInspection &&
                                                <Col xxl={12} md={12}>
                                                    <div className="d-flex align-items-right">
                                                        <div className="flex-grow-1">&nbsp;</div>
                                                        <div className="flex-shrink-0">
                                                            {fboState && fboState.ticket.inspectionNCStateResult === "NC Accepted" &&
                                                            <span className="badge bg-success" style={{padding:10}}>{fboState && fboState.ticket.inspectionNCStateResult}</span>
                                                            }
                                                            {fboState && fboState.ticket.inspectionNCStateResult === "NC Rejected" &&
                                                            <span className="badge bg-danger" style={{padding:10}}>{fboState && fboState.ticket.inspectionNCStateResult}</span>
                                                            }
                                                            {fboState && fboState.ticket.inspectionNCStateResult === "NC Pending" &&
                                                            <span className="badge bg-warning" style={{padding:10}}>{fboState && fboState.ticket.inspectionNCStateResult} : {getFormattedDate(fboState.ticket.inspectionNCEndDate) || ""}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                                }
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Ticket #</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && fboState.ticket.requestNumber) || ""}
                                                        onChange={e => onTicketChange("requestNumber", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Status</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && fboState.ticket.status) || ""}
                                                        onChange={e => onTicketChange("status", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Ticket Type</Label>
                                                    <select className="form-select" disabled={true}
                                                        value={(fboState && fboState.ticket.serviceId) || ""}
                                                        onChange={e => onTicketChange("serviceId", e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {serviceList && serviceList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.name}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </Col>
                                                {fboState && fboState.showGroup &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Group Name</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangeGroup ? false : true}
                                                            value={(fboState && fboState.ticket.groupId) || ""}
                                                            onChange={e => onGroupChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {getGroupList(fboState.ticket.groupId).map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.id}>{item.name}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Technical User</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangeGroupUser ? false : true}
                                                            value={(fboState && fboState.ticket.groupUserId) || ""}
                                                            onChange={e => onGroupUserChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {fboState && fboState.groupUserList.filter(x => x.groupId == fboState.ticket.groupId && x.isTechnicalUser === true).map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.userId}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.showDecisionMaker &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Decision Maker</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangeDecisionMaker ? false : true}
                                                            value={(fboState && fboState.ticket.decisionUserId) || ""}
                                                            onChange={e => onDecisionMakerChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {getDecisionMakerList().map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.userId}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.showPdGroup &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">PD Services Group</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangePdGroup ? false : true}
                                                            value={(fboState && fboState.ticket.pdGroupId) || ""}
                                                            onChange={e => onPdGroupChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {fboState && fboState.pdGroupList.map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.id}>{item.name}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">PD Services User</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangePdGroupUser ? false : true}
                                                            value={(fboState && fboState.ticket.pdGroupUserId) || ""}
                                                            onChange={e => onPdGroupUserChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {fboState && fboState.pdGroupUserList.filter(x => x.groupId == fboState.ticket.pdGroupId).map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.userId}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.showPdDecisionMaker &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Decision Maker</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangePdDecisionMaker ? false : true}
                                                            value={(fboState && fboState.ticket.decisionUserId) || ""}
                                                            onChange={e => onDecisionMakerChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {getDecisionMakerList().map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.userId}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.showDataReview &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Data Processing User</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangeDataReview ? false : true}
                                                            value={(fboState && fboState.ticket.dataReviewUserId) || ""}
                                                            onChange={e => onDataReviewUserChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {fboState && fboState.dataReviewList.map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.showInspectorCoordinator &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Inspector Coordinator</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangeInspectorCoordinator ? false : true}
                                                            value={(fboState && fboState.ticket.inspectionCoordinatorUserId) || ""}
                                                            onChange={e => onInspectionCoordinatorUserChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {fboState && fboState.inspectionCoordinatorList.map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.showSampler &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Sampling User</Label>
                                                        <select className="form-select" disabled={fboState && fboState.canChangeSampler ? false : true}
                                                            value={(fboState && fboState.ticket.samplingUserId) || ""}
                                                            onChange={e => onSamplingUserChange(e.target.value)}
                                                        >
                                                            <option value={0}>...</option>
                                                            {fboState && fboState.samplerList.map(function(item, index){
                                                                return (
                                                                    <option key={index} value={item.id}>{item.fullName}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && (fboState.ticket.isProductCertificateAvailable || fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) &&
                                                <Fragment>
                                                    <Col xxl={4} md={4} style={{border: (certificateTypeValid ? "" : "1px solid red")}}>
                                                        <Label className="form-label">Request Type<span className="required">*</span></Label>
                                                        <div className="form-check pt-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-0 me-5">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.certificateType === "New")}
                                                                        onChange={e => onTicketChange("certificateType", "New")}
                                                                    /> New
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.certificateType === "Renewal")}
                                                                        onChange={e => onTicketChange("certificateType", "Renewal")}
                                                                    /> Renewal
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xxl={4} md={4}>
                                                        {fboState && fboState.ticket.certificateType === "Renewal" &&
                                                        <Fragment>
                                                            <Label className="form-label">Old certificate number.<sup>2</sup></Label>
                                                            <input type="text" className="form-control"
                                                                value={(fboState && fboState.ticket.oldCertificateNumber) || ""}
                                                                onChange={e => onTicketChange("oldCertificateNumber", e.target.value)}
                                                            />
                                                        </Fragment>
                                                        }
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && (fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) &&
                                                <Fragment>
                                                    <Col xxl={4} md={6} style={{border: (testReportValid ? "" : "1px solid red")}}>
                                                        <Label className="form-label">Is there a test report?<span className="required">*</span></Label>
                                                        <div className="form-check pt-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-0 me-5">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.isValidTestReport === "Yes")}
                                                                        onChange={e => onTicketChange("isValidTestReport", "Yes")}
                                                                    /> Yes
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.isValidTestReport === "No")}
                                                                        onChange={e => onTicketChange("isValidTestReport", "No")}
                                                                    /> No
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    {fboState && fboState.ticket.isValidTestReport === "Yes" &&
                                                    <Col xxl={4} md={6} style={{border: (samplingInitiatedByValid ? "" : "1px solid red")}}>
                                                        <Label className="form-label">Sampling initiated by TUV Austria?<span className="required">*</span></Label>
                                                        <div className="form-check pt-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-0 me-5">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.samplingInitiatedBy === "Yes")}
                                                                        onChange={e => onTicketChange("samplingInitiatedBy", "Yes")}
                                                                    /> Yes
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.samplingInitiatedBy === "No")}
                                                                        onChange={e => onTicketChange("samplingInitiatedBy", "No")}
                                                                    /> No
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    }
                                                    {fboState && fboState.ticket.isValidTestReport === "No" &&
                                                    <Fragment>
                                                        <Col xxl={4} md={6}>
                                                            <Label className="form-label">Client Address<span className="required">*</span></Label>
                                                            <input type="text" className={`form-control ${clientAddressValid ? "" : "is-invalid"}`}
                                                                value={(fboState && fboState.ticket.clientAddress) || ""}
                                                                onChange={e => onTicketChange("clientAddress", e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={6}>
                                                            <Label className="form-label">Client Contact<span className="required">*</span></Label>
                                                            <input type="text" className={`form-control ${clientContactValid ? "" : "is-invalid"}`}
                                                                value={(fboState && fboState.ticket.clientContact) || ""}
                                                                onChange={e => onTicketChange("clientContact", e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={6}>
                                                            <Label className="form-label">Product Location<span className="required">*</span></Label>
                                                            <input type="text" className={`form-control ${productLocationValid ? "" : "is-invalid"}`}
                                                                value={(fboState && fboState.ticket.productLocation) || ""}
                                                                onChange={e => onTicketChange("productLocation", e.target.value)}
                                                            />
                                                        </Col>
                                                    </Fragment>
                                                    }
                                                </Fragment>
                                                }
                                                {fboState && fboState.ticket.isProductCertificateAvailable &&
                                                <Fragment>
                                                    <Col xxl={4} md={6} style={{border: (requestSubTypeValid ? "" : "1px solid red")}}>
                                                        <Label className="form-label">Please select Type<span className="required">*</span></Label>
                                                        <div className="form-check pt-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-1">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.requestSubType === "Type 1a")}
                                                                        onChange={e => onTicketChange("requestSubType", "Type 1a")}
                                                                    /> Type 1a
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.requestSubType === "Type 3")}
                                                                        onChange={e => onTicketChange("requestSubType", "Type 3")}
                                                                    /> Type 3
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <input type="radio" className="form-check-input"
                                                                        checked={(fboState && fboState.ticket.requestSubType === "Type 5")}
                                                                        onChange={e => onTicketChange("requestSubType", "Type 5")}
                                                                    /> Type 5<sup>1</sup>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Request Region<span className="required">*</span></Label>
                                                        <select className={`form-select ${regionValid ? "" : "is-invalid"}`}
                                                            value={(fboState && fboState.ticket.region) || ""}
                                                            onChange={e => onTicketChange("region", e.target.value)}
                                                        >
                                                            <option value="">...</option>
                                                            {fboState && fboState.regions && fboState.regions.map(function(region, index){
                                                                return (
                                                                    <option key={index} value={region.code}>{region.description}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.ticket.isProductCertificate &&
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">SASO Request #</Label>
                                                    <input type="text" className="form-control" readOnly={isContainer ? true: false}
                                                        value={(fboState && fboState.ticket.sasoRequestNumber) || ""}
                                                        onChange={e => onTicketChange("sasoRequestNumber", e.target.value)}
                                                    />
                                                </Col>
                                                }
                                                {fboState && fboState.ticket.isFactoryAudit &&
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">SABER Request #</Label>
                                                    <input type="text" className="form-control" readOnly={isContainer ? true: false}
                                                        value={(fboState && fboState.ticket.sasoRequestNumber) || ""}
                                                        onChange={e => onTicketChange("sasoRequestNumber", e.target.value)}
                                                    />
                                                </Col>
                                                }
                                                {fboState && fboState.ticket.isFactoryAuditAvailable &&
                                                <Col xxl={4} md={12}>
                                                    <Label className="form-label">Audit Type{fboState && fboState.isFactoryAuditCategoryRequired && <span className="required">*</span>}</Label>
                                                    <select className={`form-select ${factoryAuditCategoryValid ? "" : "is-invalid"}`}
                                                        value={(fboState && fboState.ticket.factoryAuditCategory) || ""}
                                                        onChange={e => onTicketChange("factoryAuditCategory", e.target.value)}
                                                    >
                                                        <option value="">...</option>
                                                        <option value="Initial Audit / Re-Certification">Initial Audit / Re-Certification</option>
                                                        <option value="1st Surveillance">1st Surveillance</option>
                                                        <option value="2nd Surveillance">2nd Surveillance</option>
                                                    </select>
                                                </Col>
                                                }
                                                {fboState && (fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Faseh Request #{fboState && fboState.isFasehRequestNumberRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" className="form-control"
                                                            value={(fboState && fboState.ticket.fasehRequestNumber) || ""}
                                                            onChange={e => onTicketChange("fasehRequestNumber", e.target.value)}
                                                        />
                                                    </Col>
                                                    {fboState && fboState.canViewCertificateAdded &&
                                                    <Col xxl={12} md={12}>
                                                        <Label className="form-label">A digital copy of the issued certificate has been added to the system<span className="required">*</span></Label>
                                                        <div className="form-check pt-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-0 me-5">
                                                                    <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditCertificateAdded ? false : true}
                                                                        checked={(fboState && fboState.ticket.certificateAddedTicketing === "Yes")}
                                                                        onChange={e => onTicketChange("certificateAddedTicketing", e.target.checked ? "Yes" : "No")}
                                                                    /> Ticketing System
                                                                </div>
                                                                <div className="flex-grow-0 me-5">
                                                                    <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditCertificateAdded ? false : true}
                                                                        checked={(fboState && fboState.ticket.certificateAddedCOC === "Yes")}
                                                                        onChange={e => onTicketChange("certificateAddedCOC", e.target.checked ? "Yes" : "No")}
                                                                    /> COC System
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditCertificateAdded ? false : true}
                                                                        checked={(fboState && fboState.ticket.certificateAddedGdrive === "Yes")}
                                                                        onChange={e => onTicketChange("certificateAddedGdrive", e.target.checked ? "Yes" : "No")}
                                                                    /> G-Drive
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    }
                                                </Fragment>
                                                }
                                                {fboState && fboState.ticket.isShipmentCertificate &&
                                                <Fragment>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">FOB Value</Label>
                                                        <input type="text" className="form-control"
                                                            value={(fboState && fboState.ticket.fob) || ""}
                                                            onChange={e => onTicketChange("fob", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">Currency</Label>
                                                        <select className="form-select"
                                                            value={(fboState && fboState.ticket.fobCurrency) || ""}
                                                            onChange={e => onTicketChange("fobCurrency", e.target.value)}
                                                        >
                                                            <option value={""}>...</option>
                                                            <option value="AED">UAE Dirham</option>
                                                            <option value="CNY">China Yuan</option>
                                                            <option value="EUR">Euro</option>
                                                            <option value="USD">USA Dollar</option>
                                                            <option value="LKR">Sri Lanka Rupee</option>
                                                            <option value="EGP">Egypt Pound</option>
                                                            <option value="SAR">Saudi Riyal</option>
                                                            <option value="INR">India Rupee</option>
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && fboState.ticket.isShipmentCertificate &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Shipment Country</Label>
                                                        <input type="text" className="form-control"
                                                            value={(fboState && fboState.ticket.shipmentCountry) || ""}
                                                            onChange={e => onTicketChange("shipmentCountry", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <Label className="form-label">Non Regulated Included?</Label>
                                                        <div className="form-check pt-2">
                                                            <input type="checkbox" className="form-check-input"
                                                                checked={(fboState && fboState.ticket.nonRegulated)}
                                                                onChange={e => onTicketChange("nonRegulated", e.target.checked)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col xxl={2} md={6}>
                                                        <div style={{visibility: (fboState && fboState.ticket.nonRegulated) ? "" : "hidden"}} >
                                                            <Label className="form-label">No of Product Certificates</Label>
                                                            <input type="text" className="form-control"
                                                                value={(fboState && fboState.ticket.nonRegulatedCount) || 0}
                                                                onChange={e => onTicketChange("nonRegulatedCount", e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">PCOC Number(s)</Label>
                                                        {fboState && fboState.pcocNumbers.map(function(item, index){
                                                            return(
                                                                <div className="d-flex mb-1" key={index}>
                                                                    <div className="flex-grow-1">
                                                                        <input type="text" className="form-control"
                                                                            value={(fboState && fboState.pcocNumbers[index]) || ""}
                                                                            onChange={e => onPcocNumberChange(index, e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="flex-shrink-0" style={{visibility: (index === 0 ? "" : "hidden")}}>
                                                                        <button type="button" className="btn btn-primary btn-sm btn-icon rounded-pill ms-1 mt-1" title="Add"
                                                                            onClick={() => onPcocNumberAdd(index)}
                                                                        >
                                                                            <i className="ri-add-line" />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </Col>
                                                </Fragment>
                                                }
                                                {fboState && (fboState.ticket.isProductCertificate || fboState.ticket.isFactoryAuditAvailable) &&
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Technical Regulation Name <span className="text-primary" style={{fontSize:12}}><i>(Maximum 5 options can be selected)</i></span></Label>
                                                    <Typeahead
                                                        id="fldTechnicalRegulation"
                                                        multiple
                                                        disabled={fboState && fboState.canSave ? false : true}
                                                        labelKey= {option => `${option.description}`}
                                                        options={technicalRegulationList}
                                                        placeholder="Select Technical Regulation..."
                                                        selected = {selectedTechnicalRegulation}
                                                        onChange = {(item) => onTechnicalRegulationChange(item)}
                                                    />
                                                </Col>
                                                }
                                                {fboState && fbo.canViewReporter &&
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Allow Access To <span className="text-primary" style={{fontSize:12}}><i>(Ticket will be shared with other user)</i></span></Label>
                                                    <Typeahead
                                                        id="fldReporterUserIds"
                                                        multiple
                                                        disabled={fboState && fboState.canEditReporter ? false : true}
                                                        labelKey= {option => `${option.fullName}`}
                                                        options={fboState && fboState.reporterUserList || []}
                                                        placeholder="Select Reporter..."
                                                        selected = {selectedReporter}
                                                        onChange = {(item) => onReporterChange(item)}
                                                    />
                                                </Col>
                                                }
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">My Comments</Label>
                                                    <Typeahead
                                                        id="fldTags"
                                                        multiple={true}
                                                        allowNew={true}
                                                        disabled={fboState && fboState.canSave ? false : true}
                                                        options={[]}
                                                        newSelectionPrefix="Add comment: "
                                                        placeholder="Add Comments..."
                                                        selected = {selectedTag}
                                                        onChange = {(item) => onTagChange(item)}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Team Comments</Label>
                                                    <Typeahead
                                                        id="fldTags"
                                                        multiple={true}
                                                        allowNew={true}
                                                        disabled={true}
                                                        options={[]}
                                                        newSelectionPrefix="Add a comment: "
                                                        placeholder=""
                                                        selected = {selectedTagOther}
                                                        onChange = {(item) => onTagChange(item)}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Remarks</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        maxLength={256} placeholder="optional..."
                                                        value={(fboState && fboState.ticket.description) || ""}
                                                        onChange={e => onTicketChange("description", e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    {fboState && fboState.ticket.isFactoryAuditAvailable &&
                                    <Fragment>
                                        <Card className="mb-0">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Factory Audit Document Check{fboState && fboState.isFactoryAuditDocumentCheckRequired && <span className="required">*</span>}</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                                <Row className="gy-2">
                                                    <Col xxl={12} md={12}>
                                                        <div className="form-check mb-1">
                                                            <input type="radio" className="form-check-input"
                                                                checked={getFactoryAuditTypeValue("None")}
                                                                onChange={e => setFactoryAuditTypeValue("None")}
                                                            />
                                                            <Label className="mt-0">New Factory Audit or Factory Audit not accredited or has 17065 in the same region</Label>
                                                        </div>
                                                    </Col>
                                                    <Fragment>
                                                        <Col xxl={12} md={12} className="ms-3">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("Factory Audit", "None")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("Factory Audit", "None")}
                                                                />
                                                                <Label className="mt-0">Conduct a new Factory Audit</Label>
                                                            </div>
                                                        </Col>
                                                    </Fragment>
                                                    <Col xxl={12} md={12}>
                                                        <div className="form-check mb-1">
                                                            <input type="radio" className="form-check-input"
                                                                checked={getFactoryAuditTypeValue("OurCompany")}
                                                                onChange={e => setFactoryAuditTypeValue("OurCompany")}
                                                            />
                                                            <Label className="mt-0">Factory Audit By Our Company</Label>
                                                        </div>
                                                    </Col>
                                                    <Fragment>
                                                        <Col xxl={12} md={12} className="ms-3 d-none">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("None", "OurCompany")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("None", "OurCompany")}
                                                                />
                                                                <Label className="mt-0">Less than 1 year: Proceed with Factory Audit</Label>
                                                            </div>
                                                        </Col>
                                                        <Col xxl={12} md={12} className="ms-3">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("Surveillance 1", "OurCompany")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("Surveillance 1", "OurCompany")}
                                                                />
                                                                <Label className="mt-0">More than 1 year and less than 2 years: Conduct Surveillance 1</Label>
                                                                <i className="ri-information-fill align-bottom text-primary font-14" id="documentCheckInfo1"></i>
                                                                <UncontrolledTooltip placement="top" target="documentCheckInfo1" style={{maxWidth: "500px", textAlign: "left"}}>
                                                                    <ul>
                                                                        <li>If a factory has a major change in surveillance, which doesn’t comply with requirements, we have to do a new FA by giving the reason.  - it will be invoiced</li>
                                                                        <li>Otherwise we will accept the surveillance and proceed with the request.</li>
                                                                    </ul>
                                                                </UncontrolledTooltip>
                                                            </div>
                                                        </Col>
                                                        <Col xxl={12} md={12} className="ms-3">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("Surveillance 2", "OurCompany")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("Surveillance 2", "OurCompany")}
                                                                />
                                                                <Label className="mt-0">More than 2 years and less than 3 years: Conduct Surveillance 2</Label>
                                                                <i className="ri-information-fill align-bottom text-primary font-14" id="documentCheckInfo2"></i>
                                                                <UncontrolledTooltip placement="top" target="documentCheckInfo2" style={{maxWidth: "500px", textAlign: "left"}}>
                                                                    <ul>
                                                                        <li>If a factory has a major change in surveillance, which doesn’t comply with requirements, we have to do a new FA by giving the reason.  - it will be invoiced</li>
                                                                        <li>Otherwise we will accept the surveillance and proceed with the request.</li>
                                                                    </ul>
                                                                </UncontrolledTooltip>
                                                            </div>
                                                        </Col>
                                                        <Col xxl={12} md={12} className="ms-3">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("Factory Audit", "OurCompany")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("Factory Audit", "OurCompany")}
                                                                />
                                                                <Label className="mt-0">More than 3 years(Expired): Conduct a new Factory Audit</Label>
                                                            </div>
                                                        </Col>
                                                    </Fragment>
                                                    <Col xxl={12} md={12}>
                                                        <div className="form-check mb-1">
                                                            <input type="radio" className="form-check-input"
                                                                checked={getFactoryAuditTypeValue("OtherCompany")}
                                                                onChange={e => setFactoryAuditTypeValue("OtherCompany")}
                                                            />
                                                            <Label className="mt-0">Factory Audit By Another CB</Label>
                                                        </div>
                                                    </Col>
                                                    <Fragment>
                                                        <Col xxl={12} md={12} className="ms-3">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("Surveillance", "OtherCompany")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("Surveillance", "OtherCompany")}
                                                                />
                                                                <Label className="mt-0">Less than 3 years: Proceed with Surveillance</Label>
                                                            </div>
                                                        </Col>
                                                        <Col xxl={12} md={12} className="ms-3">
                                                            <div className="form-check mb-1">
                                                                <input type="radio" className="form-check-input"
                                                                    checked={getFactoryAuditSubTypeValue("Factory Audit", "OtherCompany")}
                                                                    onChange={e => setFactoryAuditSubTypeValue("Factory Audit", "OtherCompany")}
                                                                />
                                                                <Label className="mt-0">More than 3 years(Expired): Conduct a new Factory Audit</Label>
                                                            </div>
                                                        </Col>
                                                    </Fragment>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <Card className="mb-0">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Factory Audit Schedule Information</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Audit Date / Time{fboState && fboState.isFactoryAuditScheduleRequired && <span className="required">*</span>}</Label>
                                                        <Flatpickr className="form-control"
                                                            value={(fboState && getFormattedDateTime(fboState.ticket.factoryAuditDate)) || ""}
                                                            onChange={([date]) => onTicketChange("factoryAuditDate", date)}
                                                            options={{
                                                                enableTime: true,
                                                                dateFormat: "m/d/Y H:i"
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col xxl={8} md={12}>
                                                        <Label className="form-label">Location{fboState && fboState.isFactoryAuditScheduleRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" className="form-control" 
                                                            value={(fboState && fboState.ticket.factoryAuditLocation) || ""}
                                                            onChange={e => onTicketChange("factoryAuditLocation", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Contact Person Name{fboState && fboState.isFactoryAuditScheduleRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" className="form-control"
                                                            value={(fboState && fboState.ticket.factoryAuditContactName) || ""}
                                                            onChange={e => onTicketChange("factoryAuditContactName", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Contact Person Email{fboState && fboState.isFactoryAuditScheduleRequired && <span className="required">*</span>}</Label>
                                                        <input type="text"  className={`form-control ${factoryAuditContactEmailValid ? "" : "is-invalid"}`}
                                                            value={(fboState && fboState.ticket.factoryAuditContactEmail) || ""}
                                                            onChange={e => onTicketChange("factoryAuditContactEmail", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Contact Person Phone{fboState && fboState.isFactoryAuditScheduleRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" className="form-control"
                                                            value={(fboState && fboState.ticket.factoryAuditContactPhone) || ""}
                                                            onChange={e => onTicketChange("factoryAuditContactPhone", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Mode of Inspection{fboState && fboState.isFactoryAuditScheduleRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select"
                                                            value={(fboState && fboState.ticket.factoryAuditInspectionMode) || ""}
                                                            onChange={e => onTicketChange("factoryAuditInspectionMode", e.target.value)}
                                                        >
                                                            <option value={""}>...</option>
                                                            <option value={"Remote"}>Remote</option>
                                                            <option value={"On-Site Visit"}>On-Site Visit</option>
                                                        </select>
                                                    </Col>                                                    
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <Card className="mb-0">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Factory Audit Reviewer Information</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={12}>
                                                        <Label className="form-label">Reviewer Type{fboState && fboState.isFactoryAuditReviewerRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select"
                                                            value={(fboState && fboState.ticket.factoryAuditReviewerUserType) || ""}
                                                            onChange={e => onTicketChange("factoryAuditReviewerUserType", e.target.value)}
                                                        >
                                                            <option value={""}>...</option>
                                                            <option value={"Internal"}>Internal</option>
                                                            <option value={"External"}>External</option>
                                                        </select>
                                                    </Col>
                                                    <div className="clear-div"></div>
                                                    {fboState && fboState.ticket.factoryAuditReviewerUserType === "Internal" &&
                                                    <Fragment>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">TUV Reviewer Name{fboState && fboState.isFactoryAuditReviewerRequired && <span className="required">*</span>}</Label>
                                                            <div className="input-group">
                                                                <Lookup
                                                                    clearButton 
                                                                    allowNew ={false}
                                                                    id ="fldReporter" 
                                                                    url = {`GetGroupUserLookup?isPd=1`}
                                                                    defaultSearch={(fboState && fboState.ticket.factoryAuditReviewerUserId) || ""}
                                                                    placeholder= "Select Reviewer..."
                                                                    labelKey= {option => `${option.fullName}`}
                                                                    selected = {selectedReviewer}
                                                                    onChange = {(item) => onReviewerChange(item)}
                                                                    renderMenu = {UserRenderer}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">TUV Reviewer Email</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(selectedReviewer.length > 0 && selectedReviewer[0].email) || ""}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">TUV Reviewer Phone</Label>
                                                            <input type="text" className="form-control" readOnly={true}
                                                                value={(selectedReviewer.length > 0 && selectedReviewer[0].telephoneNumber) || ""}
                                                            />
                                                        </Col>
                                                    </Fragment>
                                                    }
                                                    {fboState && fboState.ticket.factoryAuditReviewerUserType === "External" &&
                                                    <Fragment>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Reviewer Name{fboState && fboState.IsFactoryAuditReviewerRequired && <span className="required">*</span>}</Label>
                                                            <input type="text" maxLength={256} className="form-control"
                                                                value={(fboState && fboState.ticket.factoryAuditReviewerUserName) || ""}
                                                                onChange={e => onTicketChange("factoryAuditReviewerUserName", e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Reviewer Email{fboState && fboState.IsFactoryAuditReviewerRequired && <span className="required">*</span>}</Label>
                                                            <input type="text" maxLength={256} className={`form-control ${factoryAuditReviewerEmailValid ? "" : "is-invalid"}`}
                                                                value={(fboState && fboState.ticket.factoryAuditReviewerUserEmail) || ""}
                                                                onChange={e => onTicketChange("factoryAuditReviewerUserEmail", e.target.value)}
                                                            />
                                                        </Col>
                                                        <Col xxl={4} md={12}>
                                                            <Label className="form-label">Reviewer Phone</Label>
                                                            <input type="text" maxLength={256} className="form-control"
                                                                value={(fboState && fboState.ticket.factoryAuditReviewerUserPhone) || ""}
                                                                onChange={e => onTicketChange("factoryAuditReviewerUserPhone", e.target.value)}
                                                            />
                                                        </Col>
                                                    </Fragment>
                                                    }
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Fragment>
                                    }
                                    {fboState && fboState.canViewInspectionInformation &&
                                    <Card className="mb-0">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Inspection Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={3} md={12}>
                                                    <Label className="form-label">Inspection Start Date{(fboState.ticket.isInspectionAvailable || getFieldValueText("reviewForm", "InspectionDetailProvided") === "Yes") && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditInspectionInformation &&
                                                    <Flatpickr className={`form-control ${inspectionStartDateValid ? "" : "is-invalid"}`}
                                                        value={(fboState && getFormattedDateTime(fboState.ticket.inspectionStartDate)) || ""}
                                                        onChange={([date]) => onTicketChange("inspectionStartDate", date)}
                                                        options={{
                                                            dateFormat: "m/d/Y"
                                                        }}
                                                    />
                                                    }
                                                    {fboState && !fboState.canEditInspectionInformation &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && getFormattedDate(fboState.ticket.inspectionStartDate)) || ""}
                                                    />
                                                    }
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection End Date{(fboState.ticket.isInspectionAvailable || getFieldValueText("reviewForm", "InspectionDetailProvided") === "Yes") && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditInspectionInformation &&
                                                    <Flatpickr className={`form-control ${inspectionEndDateValid ? "" : "is-invalid"}`}
                                                        value={(fboState && getFormattedDate(fboState.ticket.inspectionEndDate)) || ""}
                                                        onChange={([date]) => onTicketChange("inspectionEndDate", date)}
                                                        options={{
                                                            dateFormat: "m/d/Y"
                                                        }}
                                                    />
                                                    }
                                                    {fboState && !fboState.canEditInspectionInformation &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && getFormattedDate(fboState.ticket.inspectionEndDate)) || ""}
                                                    />
                                                    }
                                                </Col>
                                                {fboState && fboState.ticket.isInspectionAvailable &&
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Shipment Mode<span className="required">*</span></Label>
                                                    <select  className="form-select" disabled={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionMode) || ""}
                                                        onChange={e => onTicketChange("inspectionMode", e.target.value)}
                                                    >
                                                        <option value="">...</option>
                                                        <option value="Road">By Road</option>
                                                        <option value="Sea">By Sea</option>
                                                        <option value="Air">By Air</option>
                                                    </select>
                                                </Col>
                                                }
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Inspection Address{(fboState.ticket.isInspectionAvailable || getFieldValueText("reviewForm", "InspectionDetailProvided") === "Yes") && <span className="required">*</span>}</Label>
                                                    <div className="d-flex gap-2">
                                                        <input type="text" maxLength={256} className={`form-control ${inspectionAddressValid ? "" : "is-invalid"}`} readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                            value={(fboState && fboState.ticket.inspectionAddress) || ""}
                                                            onChange={e => onTicketChange("inspectionAddress", e.target.value)}
                                                        />
                                                        {fboState &&
                                                        <button className="btn btn-primary btn-icon float-end"
                                                            onClick={() => setShowGoogleMap(true)}
                                                        >
                                                            <i className="ri-map-pin-line"></i>
                                                        </button>
                                                        }
                                                    </div>
                                                    
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection Country{(fboState.ticket.isInspectionAvailable || getFieldValueText("reviewForm", "InspectionDetailProvided") === "Yes") && <span className="required">*</span>}</Label>
                                                    <input type="text" maxLength={256} className={`form-control ${inspectionCountryValid ? "" : "is-invalid"}`} readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionCountry) || ""}
                                                        onChange={e => onTicketChange("inspectionCountry", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection City{(fboState.ticket.isInspectionAvailable || getFieldValueText("reviewForm", "InspectionDetailProvided") === "Yes") && <span className="required">*</span>}</Label>
                                                    <input type="text" maxLength={256} className={`form-control ${inspectionCityValid ? "" : "is-invalid"}`} readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionCity) || ""}
                                                        onChange={e => onTicketChange("inspectionCity", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection State</Label>
                                                    <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionState) || ""}
                                                        onChange={e => onTicketChange("inspectionState", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection Zip Code</Label>
                                                    <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionZipCode) || ""}
                                                        onChange={e => onTicketChange("inspectionZipCode", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection Latitude</Label>
                                                    <input type="text" className="form-control" readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionLatitude) || ""}
                                                        onChange={e => onTicketChange("inspectionLatitude", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspection Longitude</Label>
                                                    <input type="text" className="form-control" readOnly={!(fboState && fboState.canEditInspectionInformation)}
                                                        value={(fboState && fboState.ticket.inspectionLongitude) || ""}
                                                        onChange={e => onTicketChange("inspectionLongitude", e.target.value)}
                                                    />
                                                </Col>
                                                
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    }
                                    {fboState && fboState.canViewInspectorInformation &&
                                    <Card className="mb-0">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Inspector Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Inspector Contact<span className="required">*</span></Label>
                                                    {fboState && fboState.canEditInspectorInformation &&
                                                    <Lookup
                                                        clearButton 
                                                        allowNew ={false}
                                                        id ="fldInspectorLookup"
                                                        url = {`GetInspectorLookup?latitude=${fboState.ticket.inspectionLatitude || ""}&longitude=${fboState.ticket.inspectionLongitude || ""}`}
                                                        defaultSearch={(fboState && fboState.ticket.inspectionUserId) || ""}
                                                        placeholder= "Select Inspector..."
                                                        labelKey = {option => `${option.fullName}`}
                                                        selected = {selectedInspector}
                                                        onChange = {(item) => onInspectorChange(item)}
                                                        renderMenu = {InspectorRenderer}
                                                    />
                                                    }
                                                    {fboState && !fboState.canEditInspectorInformation &&
                                                    <input className="form-control" readOnly={true}
                                                        value={(selectedInspector.length > 0 && selectedInspector[0].fullName) || ""}
                                                    />
                                                    }
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Email</Label>
                                                    <input className="form-control" readOnly={true}
                                                        value={(selectedInspector.length > 0 && selectedInspector[0].email) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Telephone Number</Label>
                                                    <input className="form-control" readOnly={true}
                                                        value={(selectedInspector.length > 0 && selectedInspector[0].telephoneNumber) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">Mobile Number</Label>
                                                    <input className="form-control" readOnly={true}
                                                        value={(selectedInspector.length > 0 && selectedInspector[0].mobileNumber) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Address</Label>
                                                    <input className="form-control" readOnly={true}
                                                        value={(selectedInspector.length > 0 && selectedInspector[0].fullAddress) || ""}
                                                    />
                                                </Col>
                                                {fboState && fboState.ticket.inspectionUserType === "Company" &&
                                                <Fragment>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Person Name<span className="required">*</span></Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditInspectorInformation)}
                                                            value={(fboState && fboState.ticket.inspectionPersonName) || ""}
                                                            onChange={e => onTicketChange("inspectionPersonName", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Person Email<span className="required">*</span></Label>
                                                        <input type="text" maxLength={256} className={`form-control ${inspectionPersonEmailValid ? "" : "is-invalid"}`} readOnly={!(fboState && fboState.canEditInspectorInformation)}
                                                            value={(fboState && fboState.ticket.inspectionPersonEmail) || ""}
                                                            onChange={e => onTicketChange("inspectionPersonEmail", e.target.value)}
                                                        />
                                                    </Col>
                                                </Fragment>
                                                }
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    }
                                    {fboState && fboState.canViewSamplingInformation &&
                                    <Card className="mb-0">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Sampling Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={3} md={12}>
                                                    <Label className="form-label">Sample Collection Date<span className="required">*</span></Label>
                                                    {fboState && fboState.canEditSamplingInformation &&
                                                    <Flatpickr className="form-control"
                                                        value={(fboState && getFormattedDateTime(fboState.ticket.samplingDate)) || ""}
                                                        onChange={([date]) => onTicketChange("samplingDate", date)}
                                                        options={{
                                                            dateFormat: "m/d/Y"
                                                        }}
                                                    />
                                                    }
                                                    {fboState && !fboState.canEditSamplingInformation &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && getFormattedDate(fboState.ticket.samplingDate)) || ""}
                                                    />
                                                    }
                                                </Col>
                                                <Col xxl={6} md={6}>
                                                    <Label className="form-label">Sample Collection Location<span className="required">*</span></Label>
                                                    <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditSamplingInformation)}
                                                        value={(fboState && fboState.ticket.samplingLocation) || ""}
                                                        onChange={e => onTicketChange("samplingLocation", e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    }
                                    {fboState && fboState.canViewCustomerInfo &&
                                    <Card className="mb-0">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Customer Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">CRM Name</Label>
                                                    <select className="form-select" disabled={isCustomerReadonly()}
                                                        value={(fboState && fboState.ticket.crmName) || ""}
                                                        onChange={e => onTicketChange("crmName", e.target.value)}
                                                    >
                                                        <option value="">...</option>
                                                        {fboState && fboState.crmList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.crmName}>{item.crmLabel}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Invoice Country</Label>
                                                    <select className="form-select" disabled={isCustomerReadonly()}
                                                        value={(fboState && fboState.ticket.crmCountry) || ""}
                                                        onChange={e => onTicketChange("crmCountry", e.target.value)}
                                                    >
                                                        <option value="">...</option>
                                                        {fboState && fboState.crmCountryList.filter(x => x.crmName == fboState.ticket.crmName).map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.countryName}>{item.countryLabel}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </Col>
                                                <Col xxl={4} md={6}>&nbsp;</Col>
                                                {isCustomerReadonly() &&
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Customer Code</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].code + ' - ' + selectedCustomer[0].crmCountry) || ""}
                                                    />
                                                </Col>
                                                }
                                                {!isCustomerReadonly() &&
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Customer Code</Label>
                                                    <CustomerLookup
                                                        id ="fldCustomerLookup2"
                                                        crmName={(fboState && fboState.ticket.crmName) || ""}
                                                        selected = {selectedCustomer}
                                                        onChange = {(item) => onCustomerChange(item)}
                                                    />
                                                </Col>
                                                }
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Organization Name</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].organizationName) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Contact Name</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].fullName) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Address</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].fullAddress) || ""}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    }
                                    {fboState && fboState.canViewInvoiceInfo &&    
                                    <Card className="mb-0 card-light">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setInvoiceInformationCollapsed(!invoiceInformationCollapsed)}>
                                                {invoiceInformationCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                                {!invoiceInformationCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                                Invoice Information ({invoiceInformationCollapsed ? "Expand" : "Collapse"})
                                            </h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                            <Collapse isOpen={!invoiceInformationCollapsed} className="collapse">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">CRM Invoice #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.crmInvoiceNumber) || ""}
                                                            onChange={e => onTicketChange("crmInvoiceNumber", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Tax Invoice #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.taxInvoiceNumber) || ""}
                                                            onChange={e => onTicketChange("taxInvoiceNumber", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">CRM Quote #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.crmQuoteNumber) || ""}
                                                            onChange={e => onTicketChange("crmQuoteNumber", e.target.value)}
                                                        />
                                                    </Col>
                                                    <div className="clear-div"></div>                                                    
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Product Name</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.productName) || ""}
                                                            onChange={e => onTicketChange("productName", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={7} md={12}>
                                                        <Label className="form-label">Description</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.productDescription) || ""}
                                                            onChange={e => onTicketChange("productDescription", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={1} md={6}>
                                                        <Label className="form-label">Quantity</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.quantity) || ""}
                                                            onChange={e => onTicketChange("quantity", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6} className="pe-1">
                                                        <Label className="form-label">List Price</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.listPrice) || ""}
                                                            onChange={e => onTicketChange("listPrice", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6} className="pe-1 ps-1">
                                                        <Label className="form-label">Discount</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.discountValue) || ""}
                                                            onChange={e => onTicketChange("discountValue", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={1} md={6} className="pe-1 ps-0">
                                                        <Label className="form-label">&nbsp;</Label>
                                                        <select className="form-select" disabled={true}
                                                            value={(fboState && fboState.ticket.discountType) || ""}
                                                            onChange={e => onTicketChange("discountType", e.target.value)}
                                                        >
                                                            <option value="Percentage">Pct</option>
                                                            <option value="Amount">Amt</option>
                                                        </select>
                                                    </Col>
                                                    <Col xxl={2} md={6} className="pe-1 ps-1">
                                                        <Label className="form-label">Sale Price</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.salePrice) || ""}
                                                            onChange={e => onTicketChange("salePrice", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6} className="pe-1 ps-1">
                                                        <Label className="form-label">VAT Amount</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.vat) || ""}
                                                            onChange={e => onTicketChange("vat", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={1} md={6} className="pe-1 ps-0">
                                                        <Label className="form-label">&nbsp;</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.vatPercentage ? `${fboState.ticket.vatPercentage}%` : "0%") || "0%"}
                                                            onChange={e => onTicketChange("vatPercentage", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={2} md={6} className="ps-1">
                                                        <Label className="form-label">Total Price</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.ticket.price) || ""}
                                                            onChange={e => onTicketChange("price", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Currency</Label>
                                                        <select className="form-select" disabled={true}
                                                            value={(fboState && fboState.ticket.currency) || ""}
                                                            onChange={e => onTicketChange("currency", e.target.value)}
                                                        >
                                                            <option value={""}>...</option>
                                                            <option value="AED">UAE Dirham</option>
                                                            <option value="CNY">China Yuan</option>
                                                            <option value="EUR">Euro</option>
                                                            <option value="USD">USA Dollar</option>
                                                            <option value="LKR">Sri Lanka Rupee</option>
                                                            <option value="EGP">Egypt Pound</option>
                                                            <option value="SAR">Saudi Riyal</option>
                                                            <option value="INR">India Rupee</option>
                                                        </select>
                                                    </Col>
                                                </Row>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                    }
                                    {fboState && fboState.ticket.id > 0 && fboState.ticket.customerId &&
                                    <Card className="mb-0">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setRelatedTicketCollapsed(!relatedTicketCollapsed)}>
                                                {relatedTicketCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                                {!relatedTicketCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                                Customer Latest Tickets ({relatedTicketCollapsed ? "Expand" : "Collapse"})
                                            </h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                            <Collapse isOpen={!relatedTicketCollapsed} className="collapse">
                                                <RelatedTicketList ticketId={fboState.ticket.id} serviceId={fboState.ticket.serviceId} customerId={fboState.ticket.customerId} certificateNumber={fboState.ticket.certificateNumber} />
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                    }
                                    <Card className={`mb-0 ${(isContainer || fboState && !fboState.canViewCertificate) ? "d-none" : ""}`}>
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">{isFactoryAudit ? "Report Information" : "Certificate Information"}</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">{isFactoryAudit ? "Report #" : "Certificate #"}{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                                    <input type="text" className="form-control" readOnly={!(fboState && fboState.canEditCertificate)}
                                                        value={(fboState && fboState.ticket.certificateNumber) || ""}
                                                        onChange={e => onTicketChange("certificateNumber", e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">{isFactoryAudit ? "Report Issue Date" : "Certificate Issue Date"}{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditCertificate &&
                                                    <Flatpickr className="form-control"
                                                        value={(fboState && getFormattedDate(fboState.ticket.certificateIssueDate)) || ""}
                                                        onChange={([date]) => onTicketChange("certificateIssueDate", date)}
                                                        options={{
                                                            dateFormat: "m/d/Y",
                                                            maxDate: "today"
                                                        }}
                                                    />
                                                    }
                                                    {fboState && !fboState.canEditCertificate &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && getFormattedDate(fboState.ticket.certificateIssueDate)) || ""}
                                                    />
                                                    }
                                                </Col>
                                                {fboState && !fboState.ticket.isCosmeticAvailable && !fboState.ticket.isProcessedFoodAvailable && !fboState.ticket.isFreshFoodAvailable &&  !fboState.ticket.isChilledFoodAvailable &&
                                                <Col xxl={3} md={6}>
                                                    <Label className="form-label">{isFactoryAudit ? "Report Expiry Date" : "Certificate Expiry Date"}{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditCertificate &&
                                                    <Flatpickr className="form-control"
                                                        disabled={true}
                                                        value={(fboState && getFormattedDate(fboState.ticket.certificateExpiryDate)) || ""}
                                                        onChange={([date]) => onTicketChange("certificateExpiryDate", date)}
                                                        options={{
                                                            dateFormat: "m/d/Y"
                                                        }}
                                                    />
                                                    }
                                                    {fboState && !fboState.canEditCertificate &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(fboState && getFormattedDate(fboState.ticket.certificateExpiryDate)) || ""}
                                                    />
                                                    }
                                                </Col>
                                                }
                                                {fboState && fboState.canViewCertificateLabel &&
                                                <Col xxl={12} md={12}>
                                                    <div className="form-label" dangerouslySetInnerHTML={{__html: fboState.ticket.expiryDateLabel}}></div>
                                                </Col>
                                                }
                                                {fboState && (fboState.ticket.isCosmeticAvailable || fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) &&
                                                <Fragment>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Certificate Issued By{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                                        <select className="form-select" disabled={!(fboState && fboState.canEditCertificate)}
                                                            value={(fboState && fboState.ticket.issuedBy) || ""}
                                                            onChange={e => onTicketChange("issuedBy", e.target.value)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="TUV">TUV Platform</option>
                                                            <option value="SFDA">SFDA Platform</option>
                                                        </select>
                                                    </Col>
                                                    {fboState && fboState.ticket.issuedBy === "TUV" &&
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">COC Request #{fboState && fboState.isCertificateRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" className="form-control" readOnly={!(fboState && fboState.canEditCertificate)}
                                                            value={(fboState && fboState.ticket.cocRequestNumber) || ""}
                                                            onChange={e => onTicketChange("cocRequestNumber", e.target.value)}
                                                        />
                                                    </Col>
                                                    }
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Certificate Type</Label>
                                                        <select className="form-select" disabled={!(fboState && fboState.canEditCertificate)}
                                                            value={(fboState && fboState.ticket.certificateCategory) || ""}
                                                            onChange={e => onTicketChange("certificateCategory", e.target.value)}
                                                        >
                                                            <option value="">...</option>
                                                            <option value="SCOC">SCOC</option>
                                                            <option value="NSCOC">NSCOC</option>
                                                        </select>
                                                    </Col>
                                                </Fragment>
                                                }
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Comments / Instructions</Label>
                                                    <textarea maxLength={512} className="form-control" rows="5" readOnly={fboState && fboState.canEditCertificate ? false : true}
                                                        value={(fboState && fboState.ticket.certificateComments) || ""}
                                                        onChange={e => onTicketChange("certificateComments", e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </CardBody>
                            </Card>

                            <Card className={`${isContainer ? "d-none" : ""}`}>
                                {!isContainer && <CardLoader loading={loading || loadingLocal} />}

                                <CardBody style={{margin:0, padding:0}}>
                                    <Card className={`mb-0 ${(isContainer || fboState && !fboState.canViewManufacturer) ? "d-none" : ""}`}>
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Manufacturer Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                {fboState && fboState.ticket.isFactoryAuditAvailable &&
                                                <Fragment>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Factory Name{fboState && fboState.isManufacturerRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditManufacturer)}
                                                            value={(fboState && fboState.ticket.manufacturerFactoryName) || ""}
                                                            onChange={e => onTicketChange("manufacturerFactoryName", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Country Name{fboState && fboState.isManufacturerRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditManufacturer)}
                                                            value={(fboState && fboState.ticket.manufacturerCountryName) || ""}
                                                            onChange={e => onTicketChange("manufacturerCountryName", e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} md={12}>
                                                        <Label className="form-label">Factory Address{fboState && fboState.isManufacturerRequired && <span className="required">*</span>}</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditManufacturer)}
                                                            value={(fboState && fboState.ticket.manufacturerAddress) || ""}
                                                            onChange={e => onTicketChange("manufacturerAddress", e.target.value)}
                                                        />
                                                    </Col>
                                                </Fragment>
                                                }
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Organization Name{fboState && fboState.isManufacturerRequired && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditManufacturer &&
                                                    <div className="input-group">
                                                        <Lookup
                                                            clearButton 
                                                            allowNew ={false}
                                                            id ="fldManufacturerLookup" 
                                                            url = "GetManufacturerLookup"
                                                            defaultSearch={(fboState && fboState.ticket.manufacturerId) || ""}
                                                            placeholder= "Select Manufacturer..."
                                                            labelKey= {option => `${option.organizationName}`}
                                                            selected = {selectedManufacturer}
                                                            onChange = {(item) => onManufacturerChange(item)}
                                                            renderMenu = {VendorRenderer}
                                                        />
                                                        <div className="input-group-prepend">
                                                            <button type="button" className="btn btn-primary" onClick= {() => onViewVendorForm("manufacturer")}>
                                                                <i className="ri-add-line"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    }
                                                    {fboState && !fboState.canEditManufacturer &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedManufacturer.length > 0 && selectedManufacturer[0].organizationName) || ""}
                                                    />
                                                    }
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Contact Name</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedManufacturer.length > 0 && selectedManufacturer[0].contactName) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Email</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedManufacturer.length > 0 && selectedManufacturer[0].email) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Address</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedManufacturer.length > 0 && selectedManufacturer[0].fullAddress) || ""}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                
                                    <Card className={`mb-0 ${(isContainer || fboState && !fboState.canViewImporter) ? "d-none" : ""}`}>
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Importer Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Organization Name{fboState && fboState.isImporterRequired && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditImporter &&
                                                    <div className="input-group">
                                                        <Lookup
                                                            clearButton 
                                                            allowNew ={false}
                                                            id ="fldImporterLookup" 
                                                            url = "GetImporterLookup"
                                                            defaultSearch={(fboState && fboState.ticket.importerId) || ""}
                                                            placeholder= "Select Importer..."
                                                            labelKey= {option => `${option.organizationName}`}
                                                            selected = {selectedImporter}
                                                            onChange = {(item) => onImporterChange(item)}
                                                            renderMenu = {VendorRenderer}
                                                        />
                                                        <div className="input-group-prepend">
                                                            <button type="button" className="btn btn-primary" onClick= {() => onViewVendorForm("importer")}>
                                                                <i className="ri-add-line"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    }
                                                    {fboState && !fboState.canEditImporter &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedImporter.length > 0 && selectedImporter[0].organizationName) || ""}
                                                    />
                                                    }
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Contact Name</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedImporter.length > 0 && selectedImporter[0].contactName) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Email</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedImporter.length > 0 && selectedImporter[0].email) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Address</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedImporter.length > 0 && selectedImporter[0].fullAddress) || ""}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                
                                    <Card className={`mb-0 ${(isContainer || fboState && !fboState.canViewExporter) ? "d-none" : ""}`}>
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <h5 className="card-title mb-0 flex-grow-1">Exporter Information</h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Row className="gy-2">
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Organization Name{fboState && fboState.isExporterRequired && <span className="required">*</span>}</Label>
                                                    {fboState && fboState.canEditExporter &&
                                                    <div className="input-group">
                                                        <Lookup
                                                            clearButton 
                                                            allowNew ={false}
                                                            id ="fldExporterLookup" 
                                                            url = "GetExporterLookup"
                                                            defaultSearch={(fboState && fboState.ticket.exporterId) || ""}
                                                            placeholder= "Select Exporter..."
                                                            labelKey= {option => `${option.organizationName}`}
                                                            selected = {selectedExporter}
                                                            onChange = {(item) => onExporterChange(item)}
                                                            renderMenu = {VendorRenderer}
                                                        />
                                                        <div className="input-group-prepend">
                                                            <button type="button" className="btn btn-primary" onClick= {() => onViewVendorForm("exporter")}>
                                                                <i className="ri-add-line"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    }
                                                    {fboState && !fboState.canEditExporter &&
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedExporter.length > 0 && selectedExporter[0].organizationName) || ""}
                                                    />
                                                    }
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Contact Name</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedExporter.length > 0 && selectedExporter[0].contactName) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={4} md={6}>
                                                    <Label className="form-label">Email</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedExporter.length > 0 && selectedExporter[0].email) || ""}
                                                    />
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Address</Label>
                                                    <input type="text" className="form-control" readOnly={true}
                                                        value={(selectedExporter.length > 0 && selectedExporter[0].fullAddress) || ""}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </CardBody>
                            </Card>

                            {fboState && fboState.ticket.id > 0 && isContainer &&
                                <TicketGrid
                                    loading={loading}
                                    refId={fboState.ticket.id}
                                    groupList={fboState.groupList}
                                    groupUserList={fboState.groupUserList}
                                    canSave={fboState.canSave}
                                />
                            }

                            {fboState && fboState.ticket.id > 0 && !isContainer &&
                            <Fragment>
                                {fboState && fboState.canViewProduct &&
                                    <TicketProductGrid
                                        loading={loading}
                                        serviceId={fboState.ticket.serviceId}
                                        refId={fboState.ticket.id}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canEditProduct}
                                        onChange={reloadAction}
                                        allowMultiple={fboState && fboState.ticket.productAllowed === "Multiple"}
                                        required={fboState.isProductRequired}
                                    />
                                }
                                {!fboState.ticket.isInspectionAvailable && !fboState.ticket.isSamplingAvailable &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState.ticket.isInspectionAvailable &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        titlePrefix={"Inspection Product"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState.ticket.isSamplingAvailable &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        titlePrefix={"Sampling Product"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState && (fboState.ticket.inspectionMode === "Road" || fboState.ticket.inspectionMode === "Sea" || fboState.ticket.inspectionMode === "Air") &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_CONTAINER_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        titlePrefix={"Container/Pallet"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState && (fboState.ticket.inspectionMode === "Road" || fboState.ticket.inspectionMode === "Sea" || fboState.ticket.inspectionMode === "Air") &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_LOADING_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        titlePrefix={"Loading"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState && (fboState.ticket.inspectionMode === "Road" || fboState.ticket.inspectionMode === "Sea") &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_SEAL_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        titlePrefix={"Container Seal"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState && fboState.ticket.isSamplingAvailable &&
                                    <TicketProductPhotoGrid
                                        loading={loading}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_SAMPLING_SEAL_PHOTO"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        titlePrefix={"Sampling Seal"}
                                        skipAudit={fboState.skipAudit}
                                        canChange={fboState.canSave}
                                        onChange={onChangeDocument}
                                    />
                                }
                                {fboState && fboState.showForm0 && fboState.ticket.isProductCertificateAvailable &&
                                <Fragment>
                                    <ServiceDocumentGrid
                                        loading={loading}
                                        serviceId={fboState.ticket.serviceId}
                                        refId={fboState.ticket.id}
                                        refName={"TICKET_PRODUCT_DOCUMENT"}
                                        parentId={fboState.ticket.id}
                                        parentName={"TICKET"}
                                        isProduct={true}
                                        certificateType={fboState.ticket.certificateCategory}
                                        skipAudit={fboState.skipAudit}
                                        canAddDocument={fboState.canAddDocument}
                                        canDeleteDocument={fboState.canDeleteDocument}
                                        canAddCertificate={false}
                                        canDeleteCertificate={false}
                                        onChange={onChangeDocument} 
                                    />
                                    <Card className="mb-3">
                                        <CardHeader className="border-0 d-flex align-items-center">
                                            <CardLoader loading={loading || loadingLocal} />
                                            <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setChecklistFormCollapsed(!checklistFormCollapsed)}>
                                                {checklistFormCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                                {!checklistFormCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                                Product Checklist ({checklistFormCollapsed ? "Expand" : "Collapse"})
                                            </h5>
                                        </CardHeader>
                                        <CardBody className="border border-dashed border-end-0 border-start-0">
                                            <Collapse isOpen={!checklistFormCollapsed} className="collapse">
                                                <Row className="gy-2">
                                                    <Col xxl={12} md={12}>
                                                        <FormProductChecklistSASO
                                                            loading={loading}
                                                            fboState={fboState}
                                                            customer={selectedCustomer}
                                                            manufacturer={selectedManufacturer}
                                                            formTemplate={fboState && fboState.productChecklistForm && fboState.productChecklistForm.formTemplate ? fboState.productChecklistForm.formTemplate : null}
                                                            isValidFieldValue={isValidFieldValue}
                                                            getFieldValue={getFieldValue}
                                                            getFieldValueText={getFieldValueText}
                                                            getFieldValueDate={getFieldValueDate}
                                                            setFieldValue={setFieldValue}
                                                            setFieldValueText={setFieldValueText}
                                                            setFieldValueDate={setFieldValueDate}
                                                            setFieldValueNumber={setFieldValueNumber}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Fragment>
                                }
                            </Fragment>
                            }

                            {fboState && fboState.ticket.id > 0 && fboState.ticket.serviceId &&
                                <ServiceDocumentGrid
                                    loading={loading}
                                    serviceId={fboState.ticket.serviceId}
                                    refId={fboState.ticket.id}
                                    refName={"TICKET_DOCUMENT"}
                                    parentId={fboState.ticket.id}
                                    parentName={"TICKET"}
                                    isProduct={false}
                                    certificateType={fboState.ticket.certificateCategory}
                                    collapsed={"false"}
                                    skipAudit={fboState.skipAudit}
                                    canAddDocument={fboState.canAddDocument}
                                    canAddDocumentDate={fboState.canAddDocumentDate}
                                    canDeleteDocument={fboState.canDeleteDocument}
                                    canAddCertificate={fboState.canAddCertificate}
                                    canDeleteCertificate={fboState.canDeleteCertificate}
                                    onChange={onChangeDocument} 
                                />
                            }

                            {fboState && fboState.showForm1 && fboState.ticket.isProductCertificateAvailable &&
                                <FormReviewSASO
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.reviewForm && fboState.reviewForm.formTemplate ? fboState.reviewForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }

                            {fboState && fboState.showForm2 && fboState.ticket.isProductCertificateAvailable &&
                                <FormEvaluationSASO
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.evaluationForm && fboState.evaluationForm.formTemplate ? fboState.evaluationForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}                                    
                                />
                            }

                            {fboState && fboState.showForm3 && fboState.ticket.isProductCertificateAvailable &&
                                <FormDecisionSASO
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.decisionForm && fboState.decisionForm.formTemplate ? fboState.decisionForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }

                            {fboState && fboState.showFormReadyToIssue && fboState.ticket.isProductCertificateAvailable &&
                                <FormReadyToIssueSASO
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.readyToIssueForm && fboState.readyToIssueForm.formTemplate ? fboState.readyToIssueForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }

                            {fboState && fboState.showForm1 && (
                                fboState.ticket.isCosmeticAvailable 
                                || (fboState.ticket.isInspectionAvailable && fboState.ticket.requestType === "SFDA")
                                || (fboState.ticket.isSamplingAvailable && fboState.ticket.requestType === "SFDA")
                            ) &&
                                <FormReviewSFDA
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.reviewForm && fboState.reviewForm.formTemplate ? fboState.reviewForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                    approverFormReviewSFDA={approverFormReviewSFDA}
                                    setApproverFormReviewSFDA={setApproverFormReviewSFDA}
                                    inspectionSupervisorList={fboState && fboState.inspectionSupervisorList || []}
                                    canApproveForm1={fboState && fboState.canApproveForm1 || false}
                                />
                            }

                            {fboState && fboState.showForm2 && fboState.ticket.isCosmeticAvailable &&
                                <FormEvaluationSFDA
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.evaluationForm && fboState.evaluationForm.formTemplate ? fboState.evaluationForm.formTemplate : null}
                                    formTemplatePhase2={fboState && fboState.evaluationFormPhase2 && fboState.evaluationFormPhase2.formTemplate ? fboState.evaluationFormPhase2.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }

                            {fboState && fboState.showForm3 && fboState.ticket.isCosmeticAvailable &&
                                <FormDecisionSFDA
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.decisionForm && fboState.decisionForm.formTemplate ? fboState.decisionForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }

                            {fboState && fboState.showForm1 && (
                                fboState.ticket.isProcessedFoodAvailable
                                || fboState.ticket.isFreshFoodAvailable
                                || fboState.ticket.isChilledFoodAvailable
                                || (fboState.ticket.isInspectionAvailable && fboState.ticket.requestType === "FOOD")
                                || (fboState.ticket.isSamplingAvailable && fboState.ticket.requestType === "FOOD")
                            ) &&
                                <FormReviewFOOD
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.reviewForm && fboState.reviewForm.formTemplate ? fboState.reviewForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                    approverFormReviewSFDA={approverFormReviewSFDA}
                                    setApproverFormReviewSFDA={setApproverFormReviewSFDA}
                                    inspectionSupervisorList={fboState && fboState.inspectionSupervisorList || []}
                                    canApproveForm1={fboState && fboState.canApproveForm1 || false}
                                />
                            }

                            {fboState && fboState.showForm2 && (fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) &&
                                <FormEvaluationFOOD
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.evaluationForm && fboState.evaluationForm.formTemplate ? fboState.evaluationForm.formTemplate : null}
                                    formTemplatePhase2={fboState && fboState.evaluationFormPhase2 && fboState.evaluationFormPhase2.formTemplate ? fboState.evaluationFormPhase2.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }

                            {fboState && fboState.showForm3 && (fboState.ticket.isProcessedFoodAvailable || fboState.ticket.isFreshFoodAvailable || fboState.ticket.isChilledFoodAvailable) &&
                                <FormDecisionFOOD
                                    loading={loading}
                                    fboState={fboState}
                                    customer={selectedCustomer}
                                    manufacturer={selectedManufacturer}
                                    formTemplate={fboState && fboState.decisionForm && fboState.decisionForm.formTemplate ? fboState.decisionForm.formTemplate : null}
                                    isValidFieldValue={isValidFieldValue}
                                    getFieldValue={getFieldValue}
                                    getFieldValueText={getFieldValueText}
                                    getFieldValueDate={getFieldValueDate}
                                    setFieldValue={setFieldValue}
                                    setFieldValueText={setFieldValueText}
                                    setFieldValueDate={setFieldValueDate}
                                    setFieldValueNumber={setFieldValueNumber}
                                />
                            }
                            
                            {fboState && fboState.canSave &&
                            <Card>
                                <CardHeader className="border-0 d-flex align-items-center">
                                <div className="flex-shrink-0">
                                        <div className="d-flex flex-wrap gap-1">
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLocal || !isDirty}
                                                onClick={() => onSaveTicket()}
                                            >
                                                <i className="ri-save-line label-icon align-bottom"></i> Save Ticket {isContainer ? "Container" : ""}
                                            </button>
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || loadingLocal || !isDirty}
                                                onClick={() => onCancelTicket()}
                                            >
                                                <i className="ri-close-line label-icon align-bottom"></i> Cancel
                                            </button>
                                            {fboState && fbo.canApproveForm1 &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || loadingLocal}
                                                onClick={() => onApproveFormReviewSFDAModal()}
                                            >
                                                <i className="ri-close-line label-icon align-bottom"></i> Approve Application Review
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </CardHeader>
                            </Card>
                            }
                            
                            {fboState && fboState.ticket.id > 0 && user && !user.isExternalAudit &&
                                <CommentGrid
                                    refId={fboState.ticket.id}
                                    refName="TICKET"
                                    parentId={fboState.ticket.parentId}
                                    containerName={"[Container]"}
                                    isContainer={isContainer}
                                    onCommentAdd={reloadAction}
                                />
                            }
                        </Col>
                        {fboState && fboState.ticket.id > 0 &&
                        <Fragment>
                            <Col lg={3}>
                                {showLinkedTickets() &&
                                <Card>
                                    <CardHeader className="border-0 d-flex align-items-center">
                                        <h5 className="card-title mb-0 flex-grow-1">Linked Tickets</h5>
                                    </CardHeader>
                                    <CardBody className="border border-dashed border-end-0 border-start-0">
                                        <ListGroup className="border-dashed" flush>
                                            {fboState && fboState.ticket.samplingChildId && 
                                            <ListGroupItem className="ps-0">
                                                <Row className="align-items-center g-3">
                                                    <Col className="col">
                                                        <Link to={`/request-edit/${fboState && fboState.ticket.samplingChildId}`}>
                                                            View Sampling Ticket # [{fboState.samplingRequestNumber}]<br />
                                                            <span className="badge bg-primary">{fboState.samplingRequestStatus}</span>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                            }
                                            {fboState && fboState.ticket.inspectionChildId && 
                                            <ListGroupItem className="ps-0">
                                                <Row className="align-items-center g-3">
                                                    <Col className="col">
                                                        <Link to={`/request-edit/${fboState && fboState.ticket.inspectionChildId}`}>
                                                            View Inspection Ticket # [{fboState.inspectionRequestNumber}]<br />
                                                            <span className="badge bg-primary">{fboState.inspectionRequestStatus}</span>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                            }
                                            {user && !user.isInspector && fboState && fboState.ticket.inspectionParentId &&
                                            <ListGroupItem className="ps-0">
                                                <Row className="align-items-center g-3">
                                                    <Col className="col">
                                                        <Link to={`/request-edit/${fboState && fboState.ticket.inspectionParentId}`}>
                                                            View {fboState.parentServiceId === 5 ? "Cosmetic" : "Food"} Ticket # [{fboState.parentRequestNumber}]<br />
                                                            <span className="badge bg-primary">{fboState.parentRequestStatus}</span>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                            }
                                            {user && user.isInspector && fboState && fboState.ticket.inspectionParentId &&
                                            <ListGroupItem className="ps-0">
                                                <Row className="align-items-center g-3">
                                                    <Col className="col">
                                                        {fboState.parentServiceId === 5 ? "Cosmetic" : "Food"} Ticket # [{fboState.parentRequestNumber}]<br />
                                                        <span className="badge bg-primary">{fboState.parentRequestStatus}</span>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                            }
                                            {fboState && fboState.ticket.samplingParentId &&
                                            <ListGroupItem className="ps-0">
                                                <Row className="align-items-center g-3">
                                                    <Col className="col">
                                                        <Link to={`/request-edit/${fboState && fboState.ticket.samplingParentId}`}>
                                                            View {fboState.parentServiceId === 5 ? "Cosmetic" : "Food"} Ticket # [{fboState.parentRequestNumber}]<br />
                                                            <span className="badge bg-primary">{fboState.parentRequestStatus}</span>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                            }
                                        </ListGroup>
                                    </CardBody>
                                </Card>
                                }
                                {user && !user.isExternalAudit &&
                                <ActionList id={fboState.ticket.id} name={"TICKET"} refreshAction={refreshAction} />
                                }
                            </Col>
                        </Fragment>
                        }
                    </Row>
                </Container>
            </div>
            
            <ConfirmModal message={"Are you sure you want to Assign the Ticket?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeTicket} />
            <ConfirmModal message={"Are you sure you want to \"Submit\" the Ticket?"} show={showSubmitModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Re-Submit\" the Ticket?"} show={showReSubmitModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={fboState && fboState.ticket.isFactoryAuditAvailable ? "Are you sure you want to \"Send to PD\" the Ticket?" : "Are you sure you want to \"Send to Technical\" the Ticket?"} show={showInProgressModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Accept\" the Ticket?"} show={showAcceptModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Reject\" the Ticket?"} show={showRejectModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Sales Action\" the Ticket?"} show={showSalesActionModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"PD Review\" the Ticket?"} show={showPdReviewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Technical Review\" the Ticket?"} show={showTechnicalReviewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Technical Support\" the Ticket?"} show={showTechnicalSupportModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"PD Approve\" the Ticket?"} show={showApprovePdModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"PD Reject\" the Ticket?"} show={showRejectPdModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Final Decision\" the Ticket?"} show={showFinalDecisionModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Ready To Issue\" the Ticket?"} show={showReadyToIssueModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Scheduled\" the Ticket?"} show={showScheduledModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Waiting Corrective Action\" the Ticket?"} show={showWaitingCorrectiveActionModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Data Review\" the Ticket?"} show={showDataReviewModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Phase 1 Evaluation\" the Ticket?"} show={showPhase1EvaluationModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Phase 2 Evaluation\" the Ticket?"} show={showPhase2EvaluationModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Stopped\" the Ticket?"} show={showStoppedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Abort\" the Ticket?"} show={showAbortModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Complete\" the Ticket?"} show={showCompleteModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Close\" the Ticket?"} show={showCloseModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Cancel / Suspend\" the Ticket?"} show={showCancelModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Start Non Conformity\" the Ticket?"} show={showNonConformityModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Accept Non Conformity\" the Ticket?"} show={showAcceptNonConformityModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Reject Non Conformity\" the Ticket?"} show={showRejectNonConformityModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Reset to Draft\" the Ticket?"} show={showResetToDraftModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Reset to Sampling In Process\" the Ticket?"} show={showResetToSamplingInProcessModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            <ConfirmModal message={"Are you sure you want to \"Reset to Inspection In Process\" the Ticket?"} show={showResetToInspectionInProcessModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />

            <ConfirmModal message={"Are you sure you want to Send Create Invoice Reminder?"} show={showNotifyCreateInvoiceModal} onCloseClick={onCloseModalClick} onYesClick={onSaveNotifyInvoiceCreation} />
            <ConfirmModal message={"Are you sure you want to Send SADAD Payment Reminder?"} show={showNotifySadadPaymentModal} onCloseClick={onCloseModalClick} onYesClick={onSaveNotifySADADPayment} />
            <ConfirmModal message={"Are you sure you want to Send SADAD Paid Notification?"} show={showNotifySadadPaidModal} onCloseClick={onCloseModalClick} onYesClick={onSaveNotifySADADPaid} />

            <ConfirmModalAdvanced show={showNCRModal} onCloseClick={onCloseModalClick} onYesClick={onSaveNCR}>
                <div className="text-center pb-2">Are you sure you want to Add "NCR" Label to the Ticket?.</div>
                <Col xxl={12} md={12} className="pb-2">
                    <Label className="form-label">Enter Any Comments</Label>
                    <textarea className="form-control" rows="5"
                        value={currentMessage || ""}
                        onChange={e => setCurrentMessage(e.target.value)}
                    />
                </Col>
            </ConfirmModalAdvanced>

            <ConfirmModalAdvanced show={showVerifiedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveVerified}>
                <div className="text-center pb-2">Are you sure you want to Add "Verified" Label to the Ticket?.</div>
                <Col xxl={12} md={12} className="pb-2">
                    <Label className="form-label">Enter Any Comments</Label>
                    <textarea className="form-control" rows="5"
                        value={currentMessage || ""}
                        onChange={e => setCurrentMessage(e.target.value)}
                    />
                </Col>
            </ConfirmModalAdvanced>

            <ConfirmModal message={"Are you sure you want to Remove the Invoice Linking to the Ticket?"} show={showRemoveInvoiceModal} onCloseClick={onCloseModalClick} onYesClick={onSaveRemoveInvoice} />
            <ConfirmModal message={"All the required information is provided on this ticket. Do you want to close the Ticket?"} show={showAutoCloseModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket} />
            
            <ConfirmModalAdvanced show={showSubmitConfirmModal} onCloseClick={onCloseModalClick} onYesClick={onSaveTicket}>
                {errorMessages.length > 0 && <div className="pb-2">Below mentioned documents are checked in Product Checklist but not uploaded in the product documents.</div>}
                {errorMessages.map(function(item, index){
                    return (
                        <div key={index} className="d-flex">
                            <div className="flex-shrink-1">
                                <i className="ri-error-warning-fill align-bottom text-warning me-1"></i>
                            </div>
                            <div className="flex-grow-1">{item}.</div>
                        </div>
                    );
                })}
                {warningMessages.length > 0 && <div className="pt-2 pb-2">Ticket will be submitted for PD Review due to the following reasons.</div>}
                {warningMessages.map(function(item, index){
                    return (
                        <div key={index} className="d-flex">
                            <div className="flex-shrink-1">
                                <i className="ri-error-warning-fill align-bottom text-warning me-1"></i>
                            </div>
                            <div className="flex-grow-1">{item}.</div>
                        </div>
                    );
                })}
                <h4 className="text-center pt-2 pb-2">Are you sure you still want to Submit the Request?</h4>
            </ConfirmModalAdvanced>

            <ConfirmModal message={"Are you sure you want to Initiate Sampling?"} show={showCreateSamplingModal} onCloseClick={hideCreateSamplingModal} onYesClick={onSaveCreateSampling} />
            <ConfirmModal message={"Are you sure you want to Initiate Inspection?"} show={showCreateInspectionModal} onCloseClick={hideCreateInspectionModal} onYesClick={onSaveCreateInspection} />
            <ConfirmModal message={"Are you sure you want to Approve the Application Review Form?"} show={showApproveFormReviewSFDAModal} onCloseClick={hideApproveFormReviewSFDAModal} onYesClick={onSaveApproveFormReviewSFDA} />

            <Modal tabIndex="-1" size="xl" isOpen={showInvoiceCreateModal} toggle={hideInvoiceCreateModal} centered={true}>
                <ModalHeader>Create Invoice</ModalHeader>
                <ModalBody>
                    <CardLoader loading={loadingTicketInvoice} />
                    <Card className="card-light">
                        <CardHeader className="border-0 d-flex align-items-center">
                            <h5 className="card-title mb-0 flex-grow-1">Customer Information</h5>
                        </CardHeader>
                        <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                            <Row className="gy-2">
                                <Col xxl={4} md={6}>
                                    <Label className="form-label">CRM Name<span className="required">*</span></Label>
                                    <select className={`form-select ${crmNameValid ? "" : "is-invalid"}`}
                                        value={(fboState && fboState.ticket.crmName) || ""}
                                        onChange={e => onTicketChange("crmName", e.target.value)}
                                    >
                                        <option value="">...</option>
                                        {fboState && fboState.crmList.map(function(item, index){
                                            return (
                                                <option key={index} value={item.crmName}>{item.crmLabel}</option>
                                            );
                                        })}
                                    </select>
                                </Col>
                                <Col xxl={4} md={6}>
                                    <Label className="form-label">Invoice Country<span className="required">*</span></Label>
                                    <select className={`form-select ${crmCountryValid ? "" : "is-invalid"}`}
                                        value={(fboState && fboState.ticket.crmCountry) || ""}
                                        onChange={e => onTicketChange("crmCountry", e.target.value)}
                                    >
                                        <option value="">...</option>
                                        {fboState && fboState.crmCountryList.filter(x => x.crmName == fboState.ticket.crmName).map(function(item, index){
                                            return (
                                                <option key={index} value={item.countryName}>{item.countryLabel}</option>
                                            );
                                        })}
                                    </select>
                                </Col>
                                <Col xxl={4} md={6}>&nbsp;</Col>
                                <Col xxl={4} md={6}>
                                    <Label className="form-label">Customer Code</Label>
                                    <CustomerLookup
                                        id ="fldCustomerLookup1"
                                        crmName={(fboState && fboState.ticket.crmName) || ""}
                                        selected = {selectedCustomer}
                                        onChange = {(item) => onCustomerChange(item)}
                                        inputProps={{
                                            className: (customerValid ? "" : "is-invalid")
                                        }}
                                    />
                                </Col>
                                <Col xxl={4} md={6}>
                                    <Label className="form-label">Organization Name</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].organizationName) || ""}
                                    />
                                </Col>
                                <Col xxl={4} md={6}>
                                    <Label className="form-label">Contact Name</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].fullName) || ""}
                                    />
                                </Col>
                                <Col xxl={12} md={12}>
                                    <Label className="form-label">Address</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(selectedCustomer.length > 0 && selectedCustomer[0].fullAddress) || ""}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card className="card-light">
                        <CardHeader className="border-0 d-flex align-items-center">
                            <h5 className="card-title mb-0 flex-grow-1">Price Information</h5>
                            <div className="flex-shrink-0">
                                <div className="d-flex flex-wrap gap-2">
                                    <button className="btn btn-primary btn-label"
                                        disabled={loadingTicketInvoice}
                                        onClick={() => onViewContract()}
                                    >
                                        <i className="ri-check-double-line label-icon align-bottom"></i> Select Product
                                    </button>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                            <Row className="gy-2">
                                <Col xxl={4} md={6}>
                                    <Label className="form-label">Product Name</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(fboState && fboState.ticket.productName) || ""}
                                        onChange={e => onTicketChange("productName", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={7} md={12}>
                                    <Label className="form-label">Description</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(fboState && fboState.ticket.productDescription) || ""}
                                        onChange={e => onTicketChange("productDescription", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={1} md={6}>
                                    <Label className="form-label">Quantity</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(fboState && fboState.ticket.quantity) || ""}
                                        onChange={e => onTicketChange("quantity", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={2} md={6} className="pe-1">
                                    <Label className="form-label">List Price<span className="required">*</span></Label>
                                    <input type="text" className={`form-control ${listPriceValid ? "" : "is-invalid"}`} readOnly={true}
                                        value={(fboState && fboState.ticket.listPrice) || ""}
                                        onChange={e => onTicketChange("listPrice", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={2} md={6} className="pe-1 ps-1">
                                    <Label className="form-label">Discount</Label>
                                    <input type="text"  className={`form-control ${discountValid ? "" : "is-invalid"}`} readOnly={isPricingReadonly()} title={discountErrorMessage || ""}
                                        value={(fboState && fboState.ticket.discountValue) || ""}
                                        onChange={e => onTicketChange("discountValue", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={1} md={6} className="pe-1 ps-0">
                                    <Label className="form-label">&nbsp;</Label>
                                    <select className="form-select" disabled={isPricingReadonly()}
                                        value={(fboState && fboState.ticket.discountType) || ""}
                                        onChange={e => onTicketChange("discountType", e.target.value)}
                                    >
                                        <option value="Percentage">Pct</option>
                                        <option value="Amount">Amt</option>
                                    </select>
                                </Col>
                                <Col xxl={2} md={6} className="pe-1 ps-1">
                                    <Label className="form-label">Sale Price</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(fboState && fboState.ticket.salePrice) || ""}
                                        onChange={e => onTicketChange("salePrice", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={2} md={6} className="pe-1 ps-1">
                                    <Label className="form-label">VAT Amount</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(fboState && fboState.ticket.vat) || ""}
                                        onChange={e => onTicketChange("vat", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={1} md={6} className="pe-1 ps-0">
                                    <Label className="form-label">&nbsp;</Label>
                                    <select className="form-select" disabled={isPricingReadonly()}
                                        value={(fboState && fboState.ticket.vatPercentage) || ""}
                                        onChange={e => onTicketChange("vatPercentage", e.target.value)}
                                    >
                                        {getVatList().map((item, index) => (
                                            <option key={index} value={item}>{item}%</option>
                                        ))}
                                    </select>
                                </Col>
                                <Col xxl={2} md={6} className="ps-1">
                                    <Label className="form-label">Total Price</Label>
                                    <input type="text" className="form-control" readOnly={true}
                                        value={(fboState && fboState.ticket.price) || ""}
                                        onChange={e => onTicketChange("price", e.target.value)}
                                    />
                                </Col>
                                <Col xxl={3} md={6}>
                                    <Label className="form-label">Currency<span className="required">*</span></Label>
                                    <select className={`form-select ${currencyValid ? "" : "is-invalid"}`} disabled={true}
                                        value={(fboState && fboState.ticket.currency) || ""}
                                        onChange={e => onTicketChange("currency", e.target.value)}
                                    >
                                        <option value={""}>...</option>
                                        <option value="AED">UAE Dirham</option>
                                        <option value="CNY">China Yuan</option>
                                        <option value="EUR">Euro</option>
                                        <option value="USD">USA Dollar</option>
                                        <option value="LKR">Sri Lanka Rupee</option>
                                        <option value="EGP">Egypt Pound</option>
                                        <option value="SAR">Saudi Riyal</option>
                                        <option value="INR">India Rupee</option>
                                    </select>
                                </Col>
                                {fboState && fboState.ticket.isProductCertificate && selectedSasoRequestNumber && selectedSasoRequestNumber.map(function(item, index){
                                    return (
                                        <Col xxl={3} md={6} key={index}>
                                            <Label className="form-label">Saso Request # {selectedSasoRequestNumber.length == 1 ? "" : index + 1} <span className="required">*</span></Label>
                                            <input type="text" className={`form-control ${item && item.length > 0 ? "" : "is-invalid"}`}
                                                value={item}
                                                onChange={e => onSasoRequestNumberChange(index, e.target.value)}
                                            />
                                        </Col>
                                    );
                                })}
                            </Row>
                        </CardBody>
                    </Card>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary btn-label" disabled={loading || loadingLocal || loadingTicketInvoice} onClick={() => onSaveCreateInvoice(false)}>
                        <i className="ri-save-line label-icon align-bottom"></i> Create Invoice
                    </button>
                    <button type="button" className="btn btn-success btn-label" disabled={loading || loadingLocal || loadingTicketInvoice || !isDirty} onClick={() => onSaveCreateInvoice(true)}>
                        <i className="ri-save-line label-icon align-bottom"></i> Save
                    </button>
                    <button type="button" className="btn btn-danger btn-label" disabled={loading || loadingLocal || loadingTicketInvoice} data-dismiss="modal" onClick={hideInvoiceCreateModal}>
                        <i className="ri-close-line label-icon align-bottom"></i> Close
                    </button>
                </ModalFooter>
            </Modal>

            <Modal tabIndex="-1" size="xl" isOpen={showInvoiceViewModal} toggle={hideInvoiceViewModal} centered={true}>
                <ModalHeader>Invoice Information</ModalHeader>
                <ModalBody>
                    <CardLoader loading={loadingTicketInvoice} />
                    <Row className="gy-2">
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Assigned To</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.assignedUserName) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Total Amount</Label>
                            <div className="form-control"><MyNumberRenderer value={(ticketInvoice && ticketInvoice.totalAmount) || ""} /></div>
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Status</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.status) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>&nbsp;</Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Billing Account</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.billingAccount) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Billing City</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.billingAddressCity) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Billing State</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.billingAddressState) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Billing Country</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.billingAddressCountry) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Billing Contact</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.billingContact) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Shipping City</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.shippingAddressCity) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Shipping State</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.shippingAddressState) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Shipping Country</Label>
                            <input type="text" className="form-control" readOnly={true}
                                value={(ticketInvoice && ticketInvoice.shippingAddressCountry) || ""}
                            />
                        </Col>
                        <Col xxl={3} md={6}>
                            <Label className="form-label">Currency</Label>
                            <select className="form-select" disabled={true}
                                value={(fboState && fboState.ticket.currency) || ""}
                            >
                                <option value={""}>...</option>
                                <option value="AED">UAE Dirham</option>
                                <option value="CNY">China Yuan</option>
                                <option value="EUR">Euro</option>
                                <option value="USD">USA Dollar</option>
                                <option value="LKR">Sri Lanka Rupee</option>
                                <option value="EGP">Egypt Pound</option>
                                <option value="SAR">Saudi Riyal</option>
                                <option value="INR">India Rupee</option>
                            </select>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-danger btn-label" data-dismiss="modal" onClick={hideInvoiceViewModal}>
                        <i className="ri-close-line label-icon align-bottom"></i> Close
                    </button>
                </ModalFooter>
            </Modal>

            <Modal tabIndex="-1" size="xl" isOpen={showContractModal} toggle={hideContractModal} centered={true}>
                <ModalBody>
                    <Row className="gy-2">
                        <CardLoader loading={loadingTicketInvoiceContracts} />
                        <Col xxl={12} md={12}>
                            <h5 className="card-title mb-0 flex-grow-1">Contracts</h5>
                        </Col>
                        <Col xxl={12} md={12}>
                            <Table className="table-hover table-bordered align-middle mb-0">
                                <thead className="table-primary">
                                    <tr>
                                        <th>Qty</th>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Currency</th>
                                        <th>List Price</th>
                                        <th>Discount</th>
                                        <th>VAT</th>
                                        <th>Total Price</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ticketInvoiceContractList.length == 0 && <tr><td colSpan={9}>No Contracts Found</td></tr>}
                                    {ticketInvoiceContractList.map(function(item, index){
                                        return(
                                            <tr key={index}>
                                                <td className="text-center">1</td>
                                                <td>{item.productName}</td>
                                                <td>{item.productDescription}</td>
                                                <td>{item.currency}</td>
                                                <td>{item.listPrice}</td>
                                                <td>{item.discountAmount}</td>
                                                <td>{item.vatAmount}</td>
                                                <td>{item.totalPrice}</td>
                                                <td>
                                                    <button type="button" className="btn btn-primary" title="Select Product"
                                                        onClick={() => onContractSelect(item)}
                                                    >
                                                        Select
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className="gy-2 mt-2">
                        <CardLoader loading={loadingTicketInvoiceProducts} />
                        <Col xxl={12} md={12}>
                            <h5 className="card-title mb-0 flex-grow-1">Products</h5>
                        </Col>
                        <Col xxl={10} md={12}>
                            <div className="search-box">
                                <input type="text" className="form-control search" placeholder="Search for products..."
                                    value={productNameQuery}
                                    onChange={e => setProductNameQuery(e.target.value)}
                                />
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </Col>
                        <Col xxl={2} md={12}>
                            <button type="button" className="btn btn-primary btn-label w-100" 
                                disabled={loading}
                                onClick= {() => onSearchInvoiceProduct()}
                            >
                                <i className="ri-search-eye-line label-icon align-middle"></i> Search
                            </button>
                        </Col>
                        <Col xxl={12} md={12}>
                            <Table className="table-hover table-bordered align-middle mb-0">
                                <thead className="table-primary">
                                    <tr>
                                        <th>Qty</th>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Currency</th>
                                        <th>List Price</th>
                                        <th>Discount</th>
                                        <th>VAT</th>
                                        <th>Total Price</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ticketInvoiceProductList.length == 0 && <tr><td colSpan={9}>No Products Found</td></tr>}
                                    {ticketInvoiceProductList.map(function(item, index){
                                        return(
                                            <tr key={index}>
                                                <td className="text-center">1</td>
                                                <td>{item.productName}</td>
                                                <td>{item.productDescription}</td>
                                                <td>{item.currency}</td>
                                                <td>{item.listPrice}</td>
                                                <td>{item.discountAmount}</td>
                                                <td>{item.vatAmount}</td>
                                                <td>{item.totalPrice}</td>
                                                <td>
                                                    <button type="button" className="btn btn-primary" title="Select Product"
                                                        onClick={() => onContractSelect(item)}
                                                    >
                                                        Select
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-danger btn-label" data-dismiss="modal" onClick={hideContractModal}>
                        <i className="ri-close-line label-icon align-bottom"></i> Close
                    </button>
                </ModalFooter>
            </Modal>

            {showVendorFormModal && fboState && fboState.ticket.id > 0 && <VendorScreen type={vendorFormType} title={"Add Manufacturer"} showVendorFormModal={showVendorFormModal} hideVendorFormModal={hideVendorFormModal} />}
            <ErrorModal message={"Please select the Customer."} show={showCustomerError} onCloseClick={() => setShowCustomerError(false)} />
            <InfoModal message={"The quotation has already been created and needs confirmation in the CRM to generate an invoice."} show={showInvoiceError} onCloseClick={() => setShowInvoiceError(false)} />
                        
            <ErrorModal message={"Please select a different Technical User. Technical User and Requester can't be the same user."} show={showGroupUserVsReporterSelectionError} onCloseClick={() => setShowGroupUserVsReporterSelectionError(false)} />
            <ErrorModal message={"Please select a different Technical User. Technical User and Decision Maker can't be the same user."} show={showGroupUserVsDecisionMakerSelectionError} onCloseClick={() => setShowGroupUserVsDecisionMakerSelectionError(false)} />
            <ErrorModal message={"Please select a different Decision Maker. Decision Maker and Requester can't be the same user."} show={showDecisionMakerVsReporterSelectionError} onCloseClick={() => setShowDecisionMakerVsReporterSelectionError(false)} />
            <ErrorModal message={"Please select a different Decision Maker. Decision Maker and Technical User can't be the same user."} show={showDecisionMakerVsGroupUserSelectionError} onCloseClick={() => setShowDecisionMakerVsGroupUserSelectionError(false)} />
            <ErrorModal message={"Please select a different PD Services User. PD Services User and Decision Maker can't be the same user."} show={showPdGroupUserVsDecisionMakerSelectionError} onCloseClick={() => setShowPdGroupUserVsDecisionMakerSelectionError(false)} />
            <ErrorModal message={"Please select a different Decision Maker. Decision Maker and PD Services User can't be the same user."} show={showPdDecisionMakerVsGroupUserSelectionError} onCloseClick={() => setShowPdDecisionMakerVsGroupUserSelectionError(false)} />
            
            {fboState && showGoogleMap &&
            <GoogleMapModal
                show={showGoogleMap}
                onYesClick={onInspectionAddressSelect}
                onCloseClick={() => setShowGoogleMap(false)} 
                address={fboState.ticket.inspectionAddress || ""}
                latitude={fboState.ticket.latitude || null}
                longitude={fboState.ticket.longitude || null}
            />
            }
        </Fragment>
    );
}

export default TicketEditScreen;